import moment from "moment";
import {
  CLIENT_ROUTE,
  CONSULTANT_ROUTE,
  CONTRACTOR_ROUTE,
  RouteConstants,
} from "../router/Constants";
export const ALLURE_LOGO_BASE64 =
  "data:image/png;base64,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";
export const PHISON_CONSTRUCTION_BASE64 = ALLURE_LOGO_BASE64;

export const CustomerFeedbackQuestionType = {
  TEXT: "Text",
  MULTIPLE_CHOICE: "Multiple choice",
};
export const WITHHOLD = 1.02;

export const DATE_FORMAT = "DD/MM/YYYY";
export const MAIN_TABLE_THEME: any = "TableStyleLight9";

export const COMPANY_LOAN_TYPE = {
  BORROWED: "Borrowed from others",
  LENT: "Lent to people",
};

export const FixedAssetReceivedType = {
  PURCHASES: "Purchase",
  TRANSFER: "Transfer",
  RENT: "Rent",
  REQUESTED: "Requested",
  ASSET: "Asset",
};

export const POST_CHECK_STATUS = {
  PENDING: "Pending",
  DROPPED: "Dropped",
  ISSUED: "Issued",
};

export const MEETING_FILE_TYPE = [
  "Regular Weekly",
  "Regular Bi-Weekly",
  "Regular Monthly",
  "Regular Quarterly",
  "Regular Annual",
  "Other",
];

export const REGULAR_RECURRENCE = {
  EVERY_DAY: "Every Day",
  EVERY_WEEK: "Every Week",
  EVERY_TWO_WEEKS: "Every Two Weeks",
  EVERY_MONTH: "Every Month",
  EVERY_THREE_MONTHS: "Every Three Months",
  TWICE_A_YEAR: "Twice a Year",
  ANNUALLY: "Annually",
};

export const FixedAssetTabs = {
  FIXED_ASSET_TRANSFER_OUT: "Fixed Asset Transfer Out",
  FIXED_ASSET_ISSUE: "Fixed Asset Issue",
  FIXED_ASSET_TRANSFER_IN: "Fixed Asset Transfer In",
  FIXED_ASSET_RETURN: "Fixed Asset Return",
  FIXED_ASSET_RECEIVED: "Fixed Asset Received",
  FIXED_ASSET_TRANSFER: "FIxed Asset Transfer (E-E)",
  FUEL_ISSUE: "Fuel Issue",
  FUEL_REQUEST: "Fuel Request",
  FUEL_RECEIVING: "Fuel Received",
  REPORTS: "Fixed Asset Report",
  FIXED_ASSET_STATUS: "Fixed Asset Status",
  ACQUIRING_STATUS: "Acquiring Status",
  MATER_LIST: "Master List",
  FIXED_ASSET_REGISTRY: "Fixed Asset Registry",
  FIXED_ASSET_REGISTRY_STARTING_BALANCE:
    "Fixed Asset Registry Starting Balance",
};
export const WITHDRAW_CODE = [
  "Permanent Salary",
  "Daily Labor Salary",
  "Sub Contract Work",
  "Construction Material Purchase",
  "Machinery and Car Rental Spare Part",
  "Machine and Car Maintenance",
  "Construction and Equipment Rental",
  "Office Expense",
  "Utilities",
  "Oil",
  "Fuel",
  "Bank and Insurance Related",
  "Tax and VAT Related Items",
  "Petty Cash",
  "Contract Payments",
  "Fixed Asset",
  "Others",
];

export const DEPOSIT_CODE = [
  "Construction Payment",
  "Apartment Rental Sales",
  "Machinery Sales",
  "Real-Estate Sales",
  "Interest Income",
  "Disposal Income",
];

export const AutomaticMessageStatus = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

export const FeedbackQuestionType = {
  TEXT: "Text",
  MULTIPLE_CHOICE: "Multiple choice",
};

export const AutomaticMessageRecurrence = {
  DAILY: "Daily",
  WEEKLY: "Weekly",
  EVERY_TWO_WEEKS: "Every Two Weeks",
  MONTHLY: "Monthly",
};

export const EEIG_IMAGE_BASE64_IMAGE = "../Images/mirab.png";

// export const SubContractPlanType = {
//   NOMINATED: "Nominated",
//   DOMESTIC: "Domestic",
//   LABOUR_ONLY: "Labour Only",
// };

export const DISCIPLINE_TYPE = {
  APPRECIATION: "Appreciation",
  DISCIPLINE: "Discipline",
};

export const ALLOWANCE_POLICY_LIST = [
  "Transport Allowance",
  "Mobile Allowance",
  "Position Allowance",
];

export const FundType = {
  PENSION: "Pension",
  PROVIDENT: "Provident",
};

export const CompanyInfo = {
  name: "Mirab Construction",
  amh_name: "ምዕራብ ኮንስትራክሽን",
  AM_NAME: "ምዕራብ ኮንስትራክሽን",
};

export const DatabaseTabs = {
  ITEM_CODE: "Cost Code",
  MATERIAL_DATABASE: "Material Database",
  LABOUR_DATABASE: "Labour Database",
  STANDARD: "Standard P&G",
  PG_EXPENSE: "P&G Expense",
  EQUIPMENT_DATABASE: "Machinery Database",
  EQUIPMENT_RENTAL_DATABASE: "Equipment rental database",
};

export const PROJECT_MODULE = [
  RouteConstants.DASHBOARD,
  RouteConstants.DASHBOARDS,
  RouteConstants.EVM_DASHBOARD,
  RouteConstants.PROJECTS,
  RouteConstants.PROJECT_LIST,
  RouteConstants.CONTRACTOR_SUMMARY,
  RouteConstants.CLIENT_SUMMARY,
  RouteConstants.MASTER_SCHEDULE_SUMMARIES,
  RouteConstants.RESOURCE_APPROVAL,
  RouteConstants.SITE_HANDOVER,
  RouteConstants.REGISTER_PROJECT,
  RouteConstants.SUB_CONTRACT_LIST,
  RouteConstants.REGISTER_SUB_CONTRACT,
  RouteConstants.PROJECT_SUMMARY,
  RouteConstants.REPORT,
  RouteConstants.REGISTER_PRE_CONTRACT,
  RouteConstants.PRE_CONTRACT,
  RouteConstants.STANDARDS,
  RouteConstants.MASTER_SCHEDULE_SUMMARY,
  RouteConstants.MIRAB_REPORT,
  RouteConstants.TASK,
];

export const DOCUMENT_MODULE = [RouteConstants.DOCUMENT];

export const SITE_VISIT_MODULE = [RouteConstants.SITE_VISIT];

export const HR_MODULE = [
  RouteConstants.HUMAN_RESOURCE,
  RouteConstants.HUMAN_RESOURCE_INDEX,
];

export const PROCUREMENT_MODULE = [RouteConstants.PROCUREMENT];

export const INVENTORY_MODULE = [RouteConstants.INVENTORY];

export const FIXED_ASSET_MODULE = [RouteConstants.FIXED_ASSET];
export const FINANCE_MODULE = [RouteConstants.FINANCE];

export const PETTY_CASH_MODULE = [];

export const OPERATION_MODULE = [RouteConstants.OPERATION];

export const TASK_MODULE = [RouteConstants.TASK];

export const TENDER_MODULE = [
  RouteConstants.TENDER,
  RouteConstants.TENDER_SUBMISSION,
];

export const DATABASE_MODULE = [
  RouteConstants.DATABASE,
  RouteConstants.DATABASE_TAB,
];

export const UPLOAD_DOCUMENT_TYPE = {
  INCOMING: "Incoming Letter",
  OUTGOING: "Outgoing Letter",
  DOCUMENT: "Document",
  DESIGN: "Design",
};

export const MODULES = [
  {
    name: "Project",
    routes: PROJECT_MODULE.join("---"),
  },
  {
    name: "Human Resource",
    routes: HR_MODULE.join("---"),
  },
  {
    name: "Procurement",
    routes: PROCUREMENT_MODULE.join("---"),
  },
  {
    name: "Inventory",
    routes: INVENTORY_MODULE.join("---"),
  },
  {
    name: "Tender",
    routes: TENDER_MODULE.join("---"),
  },
  {
    name: "Database",
    routes: DATABASE_MODULE.join("---"),
  },
  {
    name: "Finance",
    routes: FINANCE_MODULE.join("---"),
  },
  {
    name: "Site Visit",
    routes: SITE_VISIT_MODULE.join("---"),
  },
  {
    name: "Fixed Assets",
    routes: FIXED_ASSET_MODULE.join("---"),
  },
  {
    name: "Task",
    routes: TASK_MODULE.join("---"),
  },
];

/**
 * 
   {
    name: "Document",
    routes: DOCUMENT_MODULE.join("---"),
  },
  {
    name: "Inventory",
    routes: INVENTORY_MODULE.join("---"),
  },
  {
    name: "Fixed Asset",
    routes: FIXED_ASSET_MODULE.join("---"),
  },
  {
    name: "Finance",
    routes: FINANCE_MODULE.join("---"),
  },
  {
    name: "Petty Cash",
    routes: PETTY_CASH_MODULE.join("---"),
  },
  {
    name: "Operation",
    routes: OPERATION_MODULE.join("---"),
  },
  {
    name: "Task",
    routes: TASK_MODULE.join("---"),
  },
 */

// PROJECT: "Project",
// DOCUMENT: "Document",
// HUMAN_RESOURCE: "Human Resource",
// PROCUREMENT: "Procurement",
// INVENTORY: "Inventory",
// FIXED_ASSET: "Fixed Asset",
// FINANCE: "Finance",
// PETTY_CASH: "Petty Cash",
// OPERATION: "Operation",

export const SubContractPlanType = {
  LABOUR_ONLY: "Labour only",
  SUPPLY_FIX: "Supply and fix",
};

export const DailyReportType = {
  LIST: "List",
  AVERAGE_WEIGHTED_COST: "Average W. Cost",
};

export const FinanceBOQReportType = {
  DAILY: "Daily Report",
  SUMMARY: "Weekly",
  BI_WEEKLY: "Bi Weekly",
  MONTHLY: "Monthly",
  TO_DATE: "To Date",
};

export const ContractSalesTypes = {
  SALES: "Sales",
  OTHER: "Other",
};

export const Currency = {
  ETB: "ETB",
  USD: "USD",
};

export const ApartmentExpenseFormType = {
  GENERAL: "General",
  SPECIFIC: "Specific",
};

export const TITLES = [
  "EXCAVATION & EARTH WORK",
  "CONCRETE WORK",
  "MASONRY WORK",
  "HCB Wall",
  "ROOFING & CLADDING",
  "METAL WORK",
  "Carpentry and Joinery",
  "Finishing Work",
  "Painting",
  "Sanitary Installations",
  "Water Containers and Trash Bins",
  "Design review and adoption",
  "Block Work",
  "Finishing",
  "Roof Work",
];

export const ApartmentExpenseType = {
  INDIRECT_COST: "Indirect cost",
  DIRECT_COST: "Direct cost",
  COMPOUND_AND_PARKING: "Compound and parking",
  ADMINISTRATION: "Administration",
  COMMISSION: "Commission",
  CONTINGENCY: "Contingency",
  OTHER: "Other",
  ESTIMATE: "Estimate cost",
};

export const PenalityTypes = {
  WRITTEN_WARNING: "Written Warning",
  FINAL_WRITTEN_WARNING: "Final Written Warning",
  CASH_PENALITY: "Cash Penality",
  TERMINATION: "Termination",
};

export const TreatmentGivenTypes = {
  FIRST_AID: "First Aid",
  SENT_TO_HOSPITAL: "Sent to hospital",
  SENT_TO_CLINIC: "Sent to clinic",
};

export const WeeklyReportCatagoryTypes = {
  SKILLED: "Skilled",
  UNSKILLED: "UnSkilled",
};

export const SeverityOfInjury = {
  MINOR: "Minor",
  MAJOR: "Major",
};

export const AttendanceType = {
  Absence: "Absence",
  TimeSheet: "TimeSheet",
};

export const ApplicationStatus = {
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  INTERVIEW: "INTERVIEW",
  FOLLOW_UP_INTERVIEW: "FOLLOW_UP_INTERVIEW",
  TEST: "TEST",
  UNDER_REVIEW: "UNDER_REVIEW",
};

export const BuildType = {
  ENTERPRISE: "Enterprise",
  PROJECT: "Project",
  ENTERPRISE_PROJECT: "Enterprise Project",
};

export const BUILD = BuildType.ENTERPRISE;

export const DocumentTabs = {
  MY_DOCUMENT: "My Document",
  SHARED_DOCUMENT: "Shared Document",
  WORK_ORDER: "Work Order",
};

export const Company = {
  NAME_ENGLISH: "Allure Construction",
  NAME_ENGLISH_LONG: "Allure Construction",
  NAME_AMHARIC: "አሉር ኮንስትራክሽን",
  NAME_ID: "AC",
  ADDRESS_AMHARIC: "አ/አ ቦሌ ክ/ከተማ ወረዳ __ አዲካ ህንጻ 6ኛ ፎቅ",
  LOGO: true,
  RENOVATION: false,
};

export const TRANSACTION_TYPE = {
  BANK_TO_BANK: "Bank to Bank",
  DEPOSIT: "Deposit", // revenue
  WITHDRAW: "Withdraw",
};

export const RFIStatus = {
  PENDING: "PENDING",
  ANSWERED: "ANSWERED",
};

export const UserAction = {
  APPROVE: "Approve",
  CHECK: "Check",
};
// export const Company = {
//   NAME_ENGLISH: "Shangi Furniture",
//   NAME_AMHARIC: "ሻንጊ  ፈርኒችር",
//   NAME_ID: "SF",
//   NAME_ENGLISH_LONG: "Shangi Furniture",
//   ADDRESS_AMHARIC: "አ/አ ቦሌ ክ/ከተማ ወረዳ __ አዲካ ህንጻ 6ኛ ፎቅ",
//   LOGO: false,
//   RENOVATION: true,
// };

// export const Company = {
//   NAME_ENGLISH: "GTS Construction",
//   NAME_AMHARIC: "GTS Construction",
//   NAME_ID: "GTS",
//   NAME_ENGLISH_LONG: "GTS Construction",
//   ADDRESS_AMHARIC: "አ/አ ቦሌ ክ/ከተማ ወረዳ __ አዲካ ህንጻ 6ኛ ፎቅ",
//   LOGO: false,
// RENOVATION:false
// };

// export const Company = {
//   NAME_ENGLISH: "Mudcon Construction",
//   NAME_AMHARIC: "Mudcon Construction",
//   NAME_ID: "Mudcon",
//   NAME_ENGLISH_LONG: "Mudcon Construction",
//   ADDRESS_AMHARIC: "__________________",
//   LOGO: false,
// RENOVATION:false
// };

export const ProjectTypes = {
  BUILDING: "Building",
  ROAD: "Road",
  WATER: "Water",
  INDUSTRY: "Industry",
  POWER: "Power",
  RENOVATION: "Renovation",
};

export const TypeOfProject = {
  PRE_CONTRACT: "pre-contract",
  POST_CONTRACT: "post-contract",
  SUB_CONTRACT: "sub-contract",
};

export const EmploymentType = {
  EMPLOYEE: "Employee",
  LABOUR: "Labour",
};

export const InventoryType = {
  MATERIAL: "Material",
  EQUIPMENT: "Equipment",
};

export const RoleType = {
  HUMAN_RESOURCE: "Human Resource",
  PROCUREMENT: "Procurement",
  PROJECT_MANAGER: "Project Manager",
  ACCOUNTING: "Accounting",
  SITE_MANAGER: "Site Manager",
  ROOT: "Root",
  CLIENT: "client",
  CONTRACTOR: "contractor",
  CONSULTANT: "consultant",
};

export const AccessType: { name: string; access: string[] }[] = [
  {
    name: RoleType.CLIENT,
    access: CLIENT_ROUTE,
  },
  {
    name: RoleType.CONTRACTOR,
    access: CONTRACTOR_ROUTE,
  },
  {
    name: RoleType.CONSULTANT,
    access: CONSULTANT_ROUTE,
  },
];

export const REBAR_SHEET_LIMIT = 32;
export const TRACKER_NAME = "Condigital-Project-Tracker";
export const ProcurementTabs = {
  MATERIAL_REQUISITION: "Material Requisition",
  PURCHASE_REQUISITION: "Purchase Requisition",
  PURCHASE_ORDER: "Purchase Order",
  PURCHASE_BILLING: "Purchase Billing",
  PROFORMA_COMPARISON: "Proforma Comparison",
  MATERIAL: "Material",
  SERVICE_LIST: "Service List",
  SUPPLIER: "Supplier",
  PROFORMA: "Proforma",
  STORE: "Store",
  ANALYTICS: "Analytics",
  PLAN: "Plan",
  PURCHASE_BUDGET_REQUISITION: "Purchase Budget Requisition",
  INTER_STORE_TRANSFER: "Inter Store Transfer",
  GRV_VALIDATION: "Voucher Validation",
  MATERIAL_MAJOR_CATEGORY: "Item Category",
  MATERIAL_SUB_CATEGORY: "Sub Category",
  MATERIAL_STARTING_BALANCE: "Material Starting Balance",
  MATERIAL_COUNT: "Material Count",
  SERVICE_REQUEST: "Service Request",
};

export const ServiceType = {
  RETENTION: "Retention",
  PAYMENT: "Payment",
  SALES: "Sales",
};

export const ContractTypes = {
  DESIGN_BID_BUILD: "Design ,Bid and Build",
  DESIGN_BUILD: "Design and Build",
};

export const BoqSuperTitle = {
  SUBSTRUCTURE: "SUB STRUCTURE",
  SUPERSTRUCTURE: "SUPER STRUCTURE",
  VARIATION_WORK: "VARIATION WORK",
};

export const MasterScheduleTabs = {
  SUMMARY: "Summary",
  CASHFLOW: "Cashflow",
  MATERIAL_SCHEDULE: "Material Schedule",
  MACHINERY_SCHEDULE: "Machinery Schedule",
  MANPOWER_SCHEDULE: "Manpower Schedule",
};

export const ResourceSupportingDocumentsTabs = {
  SUPPORTING_DOCUMENTS: "Supporting Documents",
};

export const SubContractorSiteHandoverTabs = {
  SITE_HANDOVER: "Site Handover",
};

export const TenderTabs = {
  TENDER_SUBMISSION_CHECKLIST: "Tender Submission Checklist",
  TENDER_DOCUMENTS: "Tender Documents",
  TENDER_OPENING: "Tender Opening Follow Up",
};

export const SummaryTabs = {
  INSPECTION_REGISTRY: "Inspection registry",
  PROJECT_OPERATION_REPORT: "Project operation report",
  WEEKLY_REPORT: "Weekly site report",
  MONTHLY_SUMMARY_REPORT: "Monthly Summary report",
  DAILY_REPORT: "Daily report",
  DAILY_SUMMARY: "Daily summary",
  SUB_CONTRACT_REGISTRIY: "Sub Contract Registry",
  SUB_CONTRACT_PAYMENT_UPDATED: "Sub Contract Payment",
  MATERIAL_CONSUMPTION_REPORT: "Material Consumption Report",
  MOBILIZATION_STATUS: "Mobilization Status",
  MATERIAL_TEST: "Material Test",
  MATERIAL_APPROVAL: "Material Approval",
  EVALUATION_FORMS: "Evaluation Forms",
  SUB_CONTRACT_EVALUATION: "Sub Contract Evaluation",
  CONTRACT: "Contract",
  SUMMARY: "Summary",
  BOQ: "BoQ",
  VARIATION: "Variation",
  DRAWINGS: "Drawings",
  WORK_ITEM: "Work Item",
  MASTER_SCHEDULE: "Master Schedule",
  PROJECT_DETAILS: "Project Detail",
  MINUTES_OF_MEETING: "Minutes of Meeting",
  PLAN: "Plans",
  REPORT: "Reports",
  CASH_FLOW: "Cash Flow",
  GRAND_SUMMARY: "Executed Summary",
  MEASUREMENT_CERTIFICATE: "Measurement Certificate",
  PAYMENT_CERTIFICATE: "Payment Certificate",
  SUB_CONTRACT_PAYMENT_CERTIFICATE: "Sub-Contract Payment Certificate",
  REQUESTED_PAYMENTS: "Requested Payments",
  PAYMENTS: "Payments",
  PRICE_ESCALATION: "Price Escalation",
  ANALYTICS: "Analytics",
  EDIT: "Edit",
  ACTIVITY: "Activity",
  MEETING: "Meeting",
  INSPECTION: "Inspection",
  SITE_DIARY: "Reports",
  WEEKLY_PROGRESS_REPORT: "Weekly Progress Report",
  TEST: "Material Test",
  SUBMITTAL: "Submittal",
  QUERY: "Query",
  SUBMITTAL_APPROVAL: "Submittal and Approvals",
  MEDIA: "Media",
  RFI: "RFI",
  LETTER: "Letter",
  STAFF_WORK: "Staff Works",
  RISK_LOG: "Risk Log",
  DOCUMENT: "Document",
  SITE_ORDER: "Site Order",
  MONTHLY_REPORT: "Monthly Report",
  ALLURE_WEEKLY_REPORT: "Weekly Report",
  ALLURE_QUARTERLY_REPORT: "Quarterly Report",
  ALLURE_YEARLY_REPORT: "Yearly Report",
  MEMO: "Memo",
  WEEKLY_SCHEDULE: "Mirab Weekly Schedule",
  MONTHLY_SCHEDULE: "Mirab Monthly Schedule",
  ALLURE_WEEKLY_PLAN: "Weekly Plan",
  ALLURE_MONTHLY_PLAN: "Monthly Plan",
  ALLURE_WEEKLY_SCHEDULE: "Weekly Resource Schedule",
  MATERIAL_CONSUMPTION: "Standard Unit Consumption Report",
  ALLURE_PAYMENT_SUMMARY: "Payment Summary",
  RESOURCE_MOBILIZATION: "Resource Mobilization",
  ALLURE_EQUIPMENT_REQUEST: "Equipment Request",
  ALLURE_MATERIAL_REQUEST: "Material Request",
  RESOURCE_APPROVAL: "Resource Approval",
  CONTRACTUAL_ISSUE_REPORT: "Contractual Issue",
  SUBCONTRACTOR_REQUEST: "Subcontractor Request",
  SITE_VISIT_SCHEDULE: "Site Visit Schedule",
  SITE_VISIT_CHECKLIST: "Site Visit Checklist",
  ALLURE_LABOUR_UTILIZATION: "Labour Utilization",
  PROJECT_PAYROLL: "Project Payroll",
  COST_COMPARISON: "Cost Comparison",
  MISC_EXPENSE: "Miscellaneous Expenses",
  SUB_CONTRACTOR_SELECTION: "Subcontractor Selection",
  OPRATION_ACTION_PLAN: "Project Operation Action Plan",
  APPROVAL_SCHEDULE: "Approval Schedule",
  WEATHER_CONDITION: "Weather",
  DAILY_SURVEYING: "Daily Surveying Activity",
  SITE_HANDOVER: "Site Handover",
  DAILY_SURVEYING_REPORT: "Daily Surveying Reporting",
  SITE_RAF_READING: "Site RAF Reading",
  SUBCONTRACT_RATE_APPROVAL: "Subcontract Rate Approval",
  TRANSFER_DOCUMENT_FORMAT: "Transfer Document Format",
  ASSIGNMENT_REGISTRY: "Assignment Registry",
  EQUIPMENT_REQUEST: "Equipment Request(Mirab)",
  EQUIPMENT_AND_PLANT_STATUS: "Equipment and Plant Status Report",
  EQUIPMENT_DEMOBILIATION: "Resource Demobiliation",
  PERIODICAL_EQUIPMENT: "Periodical Equipment",
  EQUIPMENT_PRODUCTIVIY: "Equipment Productivity",
  RISK_MITIGATION: "Risk Mitigation",
  JUSTIFICATION: "Justification",
  BRIEFING: "Briefing",
  CRITICAL_ISSUE: "Critical Issue",
  BUDGET_REQUEST: "Budget Request",
  BUDGET_SHIFTING_REQUEST: "Budget Shifting Request",
  INCOME_TO_BE_GENERATED: "Income to be Generated",
  BUDGET_UTILIZATION: "Budget Utilization",
  FUEL_REQUEST: "Fuel Request",
  ROAD_FUEL_REQUEST: "Fuel Request(Road)",
  FUEL_UTILIZATION: "Fuel Utilization",
  MATERIAL_PURCHASE_FOLLOW_UP: "Material Purchase Follow Up",
  MATERIAL_REQUIRED_SUMMARY: "Material Required Summary",
  SITE_VISIT_REPORT: "Site Visit Report",
  MATERIAL_UTILIZATION_SUMMARY: "Material Utilization Summary",
  PRICE_OFFER: "Price Offer",
  SUPPLY_FIX: "Supply Fix",
  LABOR_UTILIZATION: "Mirab Labour Utilization",
  LABOUR_UTILIZATION_SUMMARY: "Labour Utilization Summary",
  SITE_BOOK: "Site Book",
  SUB_CONTRACTOR_PERFORMANCE: "Sub Contractor Performance",
  SUB_CONTRACTOR_PAYMENT: "Sub Contractor Payment Summary",
  TAKEOFF: "Takeoff & Rebar",
  SUB_CONTRACT_TAKEOFF: "Sub-Contract Takeoff",
  SUBCONTRACTORS_COMMITMENT: "Subcontractors Commitment",
  SUBCONTRACTOR_PAYMENT_HANDOVER: "Subcontractor Payment Handover",
  IPC: "IPC",
  SUB_CONTRACT_PAYMENT: "Sub-Contract Payments",
  SUB_CONTRACT_HAND_OVER: "Sub-Contract Handover",
  PRICE_COMPARISON: "Price comparison",
  SUB_CONTRACT_PVR: "Sub-Contract Pay vs Report",
  DISPATCH_SUMMARY: "GRV or Dispatch Summary",
  SUB_CONTRACT_COMPARISON: "Sub-Contract Comparison",
  PAYMENT: "Payment",
  CASTING: "Casting",
  TEST_RESULT: "Test Result",
  CONCRETE_CUBE_TEST_RESULT: "Concrete Cube Test Report",
  TEMPORARY_ACCEPTANCE: "Temporary Acceptance",
  FINAL_ACCEPTANCE: "Final Acceptance",
  YEARLY_PLAN: "Yearly Plan",
  ALLURE_QUARTERLY_PLAN: "Quarterly Plan",
};

export const DateTypes = {
  DATE: "Date",
  RANGE: "Range",
};

export const PurchaseOrderType = {
  NON_REQUESTED: "Non-Requested",
  PITY_CASH_PURCHASE: "Pity Cash Purchase",
};

export const RISK_CATEGORY = ["Construction"];

export const RISK_OWNER = ["Contractor", "Consultant", "Client/Owner"];

export const RISK_RESPONSE_STRATEGY = ["Mitigate"];
export const MasterScheduleTab = {
  PROGRESS_REPORT: "Progress Report",
  USAGE_REPORT: "Usage Report",
};

export const WeatherTypes = {
  FINE: "Fine",
  GOOD: "Good",
  BAD: "Bad",
};

export const TaskDepartments = {
  MANAGEMENT: "Management",
  ENGINEERING: "Enginering Department",
  HR: "Human resource and General service Department",
  FINANCE: "Finance Department",
  MARKETING: "Marketing Department",
  SALES: "Sales Department",
  ADMIN: "Admin",
  OTHERS: "Others",
};

export const TaskPriority = {
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
} as const;

export const TaskStage = {
  NOT_STARTED: "Not Started",
  IN_PROGRESS: "In Progress",
  WAITING: "Waiting",
  COMPLETED: "Completed",
} as const;

export const TASK_DETAIL_TYPE = {
  WITH_DOCUMENT: "With Document/Letter",
  NO_FILE: "No File",
};

export const CompanyNames = [
  "Asmyr Furniture and Fixture",
  "Dengora Enterprise",
  "Ymab-Con Industrial Business PLC",
  "Birmaji Jalala PLC",
  "Crown Trading PLC",
];

export const REGULAR_TASK_REPORT_TYPE = {
  MODULE: "Module",
  TASK_REPORT: "Task Report",
};

export const ConsultantSummaryTab = {
  GRAND_SUMMARY: "Executed Summary",
  MEASUREMENT_CERTIFICATE: "Measurement Certificate",
  PAYMENT_CERTIFICATE: "Payment Certificate",
  TAKEOFF: "TakeOff",
  REBAR: "Rebar",
  LS: "Lump Sum",
};

export const SUBMITTAL_TYPES = [
  "Work Methodology",
  "Bar Optimization",
  "Site Order",
  "Site Change Order",
  "Meeting",
  "Inspection",
  "Site Report",
  "Safety Report",
  "Material Test",
  "Material Request",
  "Material Approval",
  "Query",
  "Payment",
  "Instructions",
  "Claims",
  "HSE Report",
  "Work Permit",
  "BenchMark Transfer",
];

export const PreContractTab = {
  SUMMARY: "Contract Summary",
  BOQ: "Contract BoQ",
  TAKE_OFF: "TakeOff",
  REBAR: "Rebar",
  LS: "Aggregate",
  UNIT_BREAK_DOWN: "Unit Breakdown",
};

export const InventoryTabs = {
  MATERIAL: "Material",
  SUPPLIER: "Supplier",
  INVENTORIES: "Inventory",
  REPORTS: "Summary Reports",
  REPORT: "Reports",
  REPORT_USAGE: "Report Usage",
  GOODS_RECEIVED: "Goods Received",
  GOODS_TRANSFER_OUT: "Goods Transfer Out",
  GOODS_RETURN_NOTE: "Goods Return Note",
  ASSET_GATE_PASS: "Asset Gate Pass",
  MY_FORMS: "My Forms",
  STOCK_CARD: "Stock Card",
  EQUIPMENT_MASTER_LIST: "Equipment Master List",
  FURNITURE_MASTER_LIST: "Furniture Master List",
};

export const FinanceTabs = {
  ACCOUNT: "Account",
  CUSTOMER: "Customers",
  SERVICE: "Service",
  INVOICE: "Invoices",
  PAYMENT: "Revenue",
  EXPENSE: "Expense",
  SUMMARY: "Company Finance",
  RETENTION: "Retention",
  DETAIL: "Project Finance",
  REPORT: "Reports",
  TRANSACTION: "Transactions",
  RECEIVABLE: "Receivables",
  PETTY_CASH: "Petty Cash",
  PAYABLE: "Payables",
  VEHICLE_PAYABLE: "Vehicle Payable",
  CONTRACT: "Contracts",
  COST_REVENUE_RECOGNITION: "Cost and revenue recognition",
  CONTRACT_SALES: "Contract sales",
  PAYMENT_SUMMARY: "Payment Summary",
  PAYMENTS_FOLLOW_UP: "Payment Follow Up",
  INDIRECT_COST: "Indirect Cost",
  CHARTS_OF_ACCOUNT: "Charts of accounts",
  PAYROLL: "Payroll",
  TAX_PAYMENT: "Tax & Government Payments",
};

export const OperationTabs = {
  EQUIPMENT_MASTER_LIST: "Equipment master list",
};

export const ShipmentType = {
  AIR_FREIGHT: "Air Freight",
  SEA_FREIGHT: "Sea Freight",
  LAND_FREIGHT: "Land Freight",
  TRAIN: "Train",
  EMS: "EMS",
  POST_OFFICE: "Post Office",
  DHL: "DHL",
};

export const FinanceReportType = {
  GRAND_LEDGER: "Grand Ledger",
  AGED_RECEIVABLES: "Aged Receivables",
  CASHFLOW_STATEMENT: "Cashflow Statement",
  BALANCE_SHEET: "Balance Sheet",
};

export const PayrollInterval = {
  MONTHLY: "Monthly",
  BIWEEKLY: "Bi-Weekly",
  WEEKLY: "Weekly",
  CUSTOM: "Custom",
};
export const HRTabs = {
  LABOUR: "Daily Labour",
  STAFF: "Employee",
  DEPARTMENT: "Department",
  ASSIGNED_PROJECT: "Project Team Structure",
  REPORT: "Reports",
  PAYROLL: "Payroll",
  EMPLOYEE_ATTENDANCE: "Attendance",
  MEMO: "Memo",
  EMPLOYEE_REQUEST: "Benefits",
  PROMOTION: "Promotion",
  HR_POLICY: "HR Policy",
  QR_GENERATOR: "Labor Id QR",
  DOCUMENT: "Document",
  ALLOWANCE: "Allowance",
  HIRING: "Hiring",
  REVIEW: "Review",
  RESIGNATION: "Resignation",
  PERFORMANCE: "Performance",
  DAILY_TASK: "Daily Task",
  MESSAGE: "Message",
};

export const WORK_DAYS_PER_MONTH = 26;

export const ALLOWANCE_TYPE = [
  { name: "Transport(Home to Work)", amount: 600, percentage: 0 },
  { name: "Transport (Fuel)", amount: 2200, percentage: 0 },
  { name: "Daily ", amount: 500, percentage: 0.04 },
  {
    name: "Daily (Breakfast,Lunch,Dinner)",
    amount: 300,
    percentage: 0.025,
  },
  { name: "Management", amount: 1000, percentage: 0.05 },
  {
    name: "Health Issue (Small)",
    amount: 0,
    percentage: 0.25,
  },
  {
    name: "Health Issue (Medium)",
    amount: 0,
    percentage: 0.4,
  },
  {
    name: "Health Issue (High)",
    amount: 0,
    percentage: 0.6,
  },
  {
    name: "Construction Operators",
    amount: Infinity,
    percentage: 0,
  },
  {
    name: "Gov Office Employee Hard Labour",
    amount: Infinity,
    percentage: 0,
  },
];

export const LabourStatus = {
  ACTIVE: "Active",
  TERMINATED: "Terminated",
};

export const AttendanceStatus = {
  ON_LEAVE: "On Leave",
  CLOCK_IN: "Clock In",
  CLOCK_OUT: "Clock OUT",
  ABSENT: "Absent",
  PRESENT: "Present",
};

export const ReportExpenseType = {
  MATERIAL: "Material",
  EQUIPMENT: "Equipment",
  LABOUR: "Labour",
  OVERTIME: "Overtime",
};

export const EmployeeRequestType = {
  TRAVEL_REQUEST: "Travel",
  BENEFIT_REQUEST: "Benefit",
  LEAVE_REQUEST: "Leave",
  OVERTIME_REQUEST: "Over-Time",
  LOAN: "Loan",
  HEALTH_BENEFIT_REQUEST: "Health Benefit",
};

export const LeaveRequestType = {
  MATERNAL_PRE: "Maternal (Pre Birth)",
  MATERNAL_POST: "Maternal (Post Birth)",
  PATERNAL: "Paternal",
  SICK: "Sick",

  DISABILITY: "Disability",
  BEREAVEMENT: "Bereavement",
  OTHER: "Other",
  ANNUAL: "Annual",
};

export const Units = {
  M: "M",
  M2: "M²",
  M3: "M³",
  NO: "Nº",
};

export const Sex = {
  MALE: "Male",
  FEMALE: "Female",
};

export const RepaymentType = {
  PERCENTAGE: "Percentage",
  AMOUNT_PER_MONTH: "Amount Per Month ",
};

export const LeavePaymentType = {
  PAID: "Paid",
  UNPAID: "Unpaid",
};

export const HRPolicyType = {
  LEAVE: "Leave",
  OVERTIME: "Overtime",
  ALLOWANCE: "Allowance",
  HEALTH_BENEFIT: "Health Benefit",
};

export const BenefitType = {
  MEDICAL_INSURANCE: "Medical Insurance",
  LIFE_INSURANCE: "Life Insurance",
  RETURN_PLANS: "Return Plans",
  DISABILITY_INSURANCE: "Disability Insurance",
  OTHER: "Other",
};

export const EquipmentTabs = {
  EQUIPMENT: "Equipment",
  REPORTS: "Summary Reports",
  REPORT: "Report Operation",
  WORK_ORDER: "Work Order",
};

export const EquipmentType = {
  RENT: "Rent",
  PURCHASE: "Purchase",
};

export const ManpowerType = {
  STAFF: "Staff",
  LABOUR: "Labour",
};

export const InventoryReport = {
  TRANSFER: "Transfer",
  USAGE: "Usage",
  OPERATION: "Operation",
  WORK_ORDER: "Work-Order",
};

export const ApprovalType = {
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  ADVANCE: "Advance Payment",
};

export const ApprovalValue = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
  ADVANCE: 3,
};

export const SupplierType = {
  LOCAL: "Local",
  FOREIGN: "Foreign",
};

export const LabourType = {
  SKILLED: "Skilled",
  UNSKILLED: "UnSkilled",
};

export const AnalyticsType = {
  PERFORMANCE: "Project Performance",
  CONTRACT_PERFORMED: "Contract Vs. Performed Vs. Planned",
  SCHEDULE_PERFORMANCE: "Schedule Performance",
  PAID_EXPENSE_PROFIT: "Paid Vs. Expense Vs. Profit",
  PERFORMED_PAID: "Performed Vs. Paid",
  PROFIT_MARGIN: "Profit Margin",
};

export const ReportType = {
  PROGRESS_REPORT: "Progress Report",
  VARIATION: "Variation",
  OVERTIME: "Overtime",
  EXPENSE_REPORT: "Expense Report",
  PETTY_CASH: "Petty Cash",
  SUB_CONTRACT_REPORT: "Sub-Contract Report",
};

export const ProjectCardType = {
  TOTAL: "Total",
  BUILDING: "Building",
  ROAD: "Road",
  POWER: "Power",
  WATER: "Water",
  INDUSTRIES: "Industries",
  RENOVATION: "Renovation",
};

export const ClientCard = {
  PROJECTS: "My Projects",
  DOCUMENTS: "My Documents",
  EMPLOYEES: "Employees",
  INVENTORY: "My Inventory",
};

export const ProgressType = {
  REBAR: "Rebar",
  TAKEOFF: "Takeoff",
  ROAD: "Road",
  LS: "LS",
};

export const LSType = {
  DIVIDED_BY_LOCATION: "Divided By Location",
  AGGREGATE: "Aggregate",
};

export const DateType = {
  DATE: "date",
  WEEK: "week",
  MONTH: "month",
  QUARTER: "quarter",
  YEAR: "year",
};

export const ProjectStatus = {
  PRE_CONTRACT: 0,
  POST_CONTRACT: 1,
  STALLED: 2,
  FINISHED: 3,
};

export const PlanTabs = {
  INCOME_SUMMARY: "Income-Breakdown",
  EXPENSE_SUMMARY: "Summary",
  MODE_OF_PAYMENT: "Execution Plan",
  ACTIVITY_PLAN: "Activity-Plan",
  UNIT_BREAKDOWN: "Unit Breakdown",
  SUB_CONTRACT: "Sub-Contract",
  RESOURCE_STATUS: "Resource Status",
  EQUIPMENT_SCHEDULE: "Equipment Schedule",
  MATERIAL_SCHEDULE: "Material Schedule",
  PERMANENT_LABOUR: "Permanent Manpower",
  TEMPORARY_LABOUR: "Temporary Manpower",
  EMPLOYEE_ACCOMMODATION_PLAN: "Employee Accommodation",
  OTHER_EXPENSE: "Other Expense",
};

export const ReportSummaryTabs = {
  TO_DATE_PROJECT_INFO: "To-Date Project Info",
  INCOME_EXPENSE_SUMMARY: "Income  Summary",
  DETAIL_REVENUE: "Detail Revenue",
  EXPENSE_ANALYSIS: "Expense Analysis",
  EXPENSE: "Expense",
  MAN_POWER_COST_SUMMARY: "Man Power Cost Summary",
  EARNED_VALUE: "Earned Value",
};

export const BudgetStatus = {
  OVER_BUDGET: "Over-Budget",
  UNDER_BUDGET: "Under-Budget",
  ON_BUDGET: "On-Budget",
  UNDETERMINED: "-",
  UNDER_PERFORMED: "Under-Performed",
  PERFORMED_AS_PLANNED: "Performed As Planned",
  OVER_PERFORMED: "Over-Performed",
};
export const ExpenseAnalysisType = {
  PERFORMANCE: "performance",
  BUDGET: "budget",
};

export const ExpenseType = {
  PLANNED: "planned",
  ACTUAL: "actual",
};

export const ExecutedType = {
  CURRENT: "current",
  PREVIOUS: "previous",
  TODATE: "to_date",
};

export const WorkTime = {
  IN_TIME: moment("9:00", "h:mm"),
  OUT_TIME: moment("17:00", "h:mm"),
  LUNCH_TIME_IN: moment("12:00", "h:mm"),
  LUNCH_TIME_OUT: moment("12:00", "h:mm"),
};

export const DateComponentType = {
  REPORT: "report",
  PLAN: "plan",
};

export const Region = [
  "Addis Abeba",
  "Afar",
  "Amhara",
  "Tigray",
  "Benshangul",
  "Dire Dawa",
  "Gambela",
  "Harar",
  "Oromia",
  "Somalia",
  "SNNPR",
];

export const NotificationType = {
  SUCCESS: "success",
  ERROR: "error",
  WARRING: "warning",
  INFO: "info",
};

export const SubContractType = {
  SUPPLY: "Supply",
  LABOUR: "Labour",
  SUPPLY_AND_FIX: "Supply and Fix",
};

export const SubmittalAction = {
  APPROVAL: "Approval",
  REVIEW: "Review",
  FOR_INFORMATION: "For Information",
  FOR_PRELIMINARY: "For Preliminary",
};

export const SubmittalItemType = {
  NEW: "New Submittal",
  RESUBMISSION: "Resubmission",
};

export const MaterialRequestType = {
  APPROVAL_REQUEST: "Material Approval Request",
  APPROVAL_RESUBMISSION: "Material Approval Resubmission",
};

export const PerformanceMeterics = {
  yes_no: "Yes/No",
  percentage: "Percentage",
};

export const ReviewTime = {
  EVERY_DAY: "Every Day",
  EVERY_WEEK: "Every Week",
  EVERY_MONTH: "Every Month",
  EVERY_YEAR: "Every Year",
};

export const FC_CONSTANTS: any = {
  0: 0,
  7: 0.65,
  14: 0.9,
  28: 1,
};

export const MU = 1.64;

export const SiteBookType = [
  "Design Change",
  "Quantity",
  "Variation",
  "Suspension",
  "Material Change",
  "Rectification (Work)",
  "Other",
];

export const Message = {
  POST_CHECK_UPDATE_SUCCESS: "Post Check Updated!",
  POST_CHECK_UPDATE_FAILED: "Failed to Update Post Check",

  POST_CHECK_DELETE_SUCCESS: "Post Check Deleted!",
  POST_CHECK_DELETE_FAILED: "Failed to Delete Post Check",

  CRV_PAYMENT_REGISTERED_SUCCESS: "CRV Payment Registered!",
  CRV_PAYMENT_REGISTERED_FAILED: "CRV Payment Registration failed!",

  CRV_PAYMENT_EDIT_SUCCESS: "CRV Payment Edited!",
  CRV_PAYMENT_EDIT_FAILED: "CRV Payment Edit failed!",

  ACCOUNT_TRANSACTION_UPDATE_SUCCESS: "Account Transaction Updated!",
  ACCOUNT_TRANSACTION_UPDATE_FAILED: "Account Transaction Update failed!",

  ACCOUNT_TRANSACTION_REGISTERED_SUCCESS: "Account Transaction Registered!",
  ACCOUNT_TRANSACTION_REGISTERED_FAILED:
    "Account Transaction Registration failed!",

  STAFF_ATTENDANCE_REGISTRATION_SUCCESS:
    "Staff Attendance Registration success!",
  STAFF_ATTENDANCE_REGISTRATION_FAILED: "Failed to register Staff Attendance",

  TRAVEL_REGISTRY_UPDATE_SUCCESS: "Travel Registry update success!",
  TRAVEL_REGISTRY_UPDATE_FAILED: "Failed to update Travel Registry",

  TRAVEL_REGISTRY_REGISTRATION_SUCCESSFUL:
    "Travel Registry registration success!",
  TRAVEL_REGISTRY_REGISTRATION_FAILED: "Failed to register Travel Registry",

  TRAVEL_REGISTRY_DELETE_SUCCESS: "Travel Registry deleted successfully!",
  TRAVEL_REGISTRY_DELETE_FAILED: "Failed to delete Travel Registry",

  LOAN_EXTENSION_REGISTRATION_SUCCESS:
    "Loan Extension registered successfully!",
  LOAN_EXTENSION_REGISTRATION_FAILED: "Failed to register Loan Extension",

  LOAN_EXTENSION_DELETE_SUCCESS: "Loan Extension deleted successfully!",
  LOAN_EXTENSION_DELETE_FAILED: "Failed to delete Loan Extension",

  LOAN_UPDATE_SUCCESS: "Loan Update success!",
  LOAN_UPDATE_FAILED: "Failed to update Loan",

  LOAN_REGISTRATION_SUCCESS: "Loan Registration success!",
  LOAN_REGISTRATION_FAILED: "Failed to register Loan",

  LOAN_DELETE_SUCCESS: "Loan deleted successfully!",
  LOAN_DELETE_FAILED: "Failed to delete Loan",

  STAFF_MEAL_REGISTRATION_SUCCESS: "Staff Meal registered successfully!",
  STAFF_MEAL_REGISTRATION_FAILED: "Failed to register Staff Meal",

  REGISTER_SUCCESS: "Successfully Registered!",
  REGISTER_FAILED: "Failed to Register",

  SIGNATURE_UPLOAD_SUCCESS: "Signature uploaded successfully!",
  SIGNATURE_UPLOAD_FAILED: "Signature uploaded failed",

  EMPLOYEE_BIO_UPDATE_SUCCESS: "Employee Bio Update success!",
  EMPLOYEE_BIO_UPDATE_FAILED: "Failed to updated Employee Bio",

  MATERIAL_DATABASE_ITEM_UPDATED: "Material database item updated",
  MATERIAL_DATABASE_ITEM_NOT_UPDATED: "Material database item not updated",
  PRICE_REPORT_DELETED: "Price report deleted",
  PRICE_REPORT_NOT_DELETED: "Price report not deleted",
  PRICE_REPORT_SUCCESS: "Price Report Added",
  PRICE_REPORT_FAILED: "Price Report Not Failed",
  MATERIAL_DATABASE_SUCCESS: "Material database added",
  MATERIAL_DATABASE_ERROR: "Material database failed",
  ITEM_DELETED: "Item Deleted",
  MASTER_LIST_UPDATE_SUCCESS: "Master List Updated Successfully!",
  MASTER_LIST_UPDATE_FAILED: "Failed to Update Master List",
  UPDATE_SUCCESS: "Successfully Updated!",
  UPDATE_FAILED: "Failed to Update ",
  UPDATED: "Updated",
  NOT_UPDATED: "Not updated",
  DELETED: "Deleted",
  NOT_DELETED: "Not deleted",
  INSPECTION_REGISTRY_DELETED: "Inspection registry deleted",
  ITEM_NOT_DELETED: "Item not deleted",
  UPLOAD_SUCCESS: "Upload successful",
  UPLOAD_FAILED: "Upload failed",
  LABOUR_ATTENDANCE_REMOVED: "Attendance Removed!",
  LABOUR_ATTENDANCE_FAILED: "Failed to Remove Attendance!",
  BONUS_SUCCESS: "Bonus successfully registered",
  BONUS_FAILED: "Bonus is not registered",
  DELETE_BONUS_SUCCESS: "Bonus deleted",
  DELETE_BONUS_FAILED: "Bonus not deleted",
  ADD_EMPLOYEE_REVIEW_SUCCESS: "Employee review added successfully",
  ADD_EMPLOYEE_REVIEW_FAILED: "Employee review could not be added",
  EMPLOYEE_REVIEW_UPDATE_SUCCESS: "Employee review updated Successfully",
  EMPLOYEE_REVIEW_UPDATE_FAILURE: "Employee review update failed",
  DELETE_EMPLOYEE_REVIEW_SUCCESS: "Employee review deleted",
  DELETE_EMPLOYEE_REVIEW_FAILED: "Employee review not deleted",
  REVIEW_FORM_UPDATE_SUCCESS: "Review form updated",
  REVIEW_FORM_UPDATE_FAILURE: "Review form update failed",
  REVIEW_FORM_SUCCESS: "Review Form Added Successfully",
  REVIEW_FORM_FAILURE: "Review form not added",
  DELETE_REVIEW_FORM_SUCCESS: "Review form deleted",
  DELETE_REVIEW_FORM_FAILED: "Review form not deleted",
  PROJECT_REGISTRATION_SUCCESS: "Project Registered!",
  PROJECT_REGISTRATION_FAILED: "Project Registration Failed!",
  BOQ_EDIT_SUCCESS: "BoQ Edited",
  BOQ_EDIT_FAILED: "Failed to Edit BoQ ",
  MODE_OF_PAYMENT_SUCCESS: "Execution Plan Registered!",
  MODE_OF_PAYMENT_FAILED: "Execution Plan Failed!",
  ACTIVITY_PLAN_SUCCESS: "Activity Plan Registered!",
  ACTIVITY_PLAN_FAILED: "Activity Plan Failed!",
  SUB_CONTRACT_PLAN_SUCCESS: "Sub Contract Plan Registered!",
  SUB_CONTRACT_PLAN_FAILED: "Sub Contract Plan Failed!",
  RESOURCE_STATUS_SUCCESS: "Resource Status Registered!",
  RESOURCE_STATUS_FAILED: "Resource Status Failed!",
  CAN_NOT_REMOVE_ITEM: "Can not remove item",
  REMOVE_FAIL: "Can not remove registered data",
  REBAR_FAILED: "Rebar Report Failed!",
  REBAR_SUCCESS: "Rebar Reported!",
  REBAR_REMOVE_FAILED: "Failed to Remove Rebar!",
  REBAR_REMOVE_SUCCESS: "Rebar Removed!",
  TAKEOFF_FAILED: "Takeoff Report Failed!",
  TAKEOFF_SUCCESS: "Takeoff Reported!",
  TAKEOFF_REMOVE_FAILED: "Failed to Remove Takeoff!",
  TAKEOFF_REMOVE_SUCCESS: "Takeoff Remove Failed",
  GENERAL_SUCCESS: "Report Successful!",
  PAYMENT_CERTIFICATE_SUCCESS: "Payment Certificate Registered!",
  PAYMENT_CERTIFICATE_FAILED: "Payment Certificate Registration Failed!",

  MATERIAL_SUCCESS: "Material Registered!",
  MATERIAL_FAILED: "Material Registration Failed!",
  SUPPLIER_SUCCESS: "Supplier Registered!",
  SUPPLIER_FAILED: "Supplier Registration Failed!",
  SUPPLIER_DELETED: "Supplier Deleted!",
  MATERIAL_MAJOR_CATEGORY_SUCCESS: "Material Major Category Saved!",
  MATERIAL_MAJOR_CATEGORY_FAILED: "Material Major Category Failed!",
  MATERIAL_MAJOR_CATEGORY_DELETED: "Material Major Category Deleted!",
  MATERIAL_SUB_CATEGORY_SUCCESS: "Material Sub Category Saved!",
  MATERIAL_SUB_CATEGORY_FAILED: "Material Sub Category Failed!",
  MATERIAL_SUB_CATEGORY_DELETED: "Material Sub Category Deleted!",
  INVENTORY_SUCCESS: "Inventory Registered",
  INVENTORY_FAILED: "Inventory Registration Failed!",
  TRANSFER_SUCCESS: "Transfer Successful!",
  TRANSFER_FAILED: "Transfer Failed!",

  ITEM_UPDATED: "Item updated",
  ITEM_NOT_UPDATED: "Item not updated",

  ITEM_ADDED: "Item added",
  ITEM_NOT_ADDED: "Item not added",

  ESTIMATE_UPDATED: "Estimate updated",
  ESTIMATE_NOT_UPDATED: "Estimate not updated",

  ESTIMATE_DELETED: "Estimate deleted",
  ESTIMATE_NOT_DELETED: "Estimate not deleted",

  ESTIMATE_SUCCESS: "Estimate added",
  ESTIMATE_FAILED: "Estimate not added",

  USER_REGISTRATION_SUCCESS: "User Registration Successful",
  USER_REGISTRATION_FAILED: "Failed to Register User",

  LABOUR_SUCCESS: "Labour Registered",
  LABOUR_FAILED: "Labour Registration Failed!",

  LABOUR_USAGE_SUCCESS: "Labour Usage Registered",
  LABOUR_USAGE_FAILED: "Labour Usage Registration Failed!",

  EQUIPMENT_SCHEDULE_SUCCESS: "Equipment Schedule Registered",
  EQUIPMENT_SCHEDULE_FAILED: "Equipment Schedule Registration Failed!",

  MATERIAL_SCHEDULE_SUCCESS: "Material Schedule Registered",
  MATERIAL_SCHEDULE_FAILED: "Material Schedule Registration Failed!",

  TEMPORARY_LABOUR_SUCCESS: "Labour Registered",
  TEMPORARY_LABOUR_FAILED: "Labour Registration Failed!",

  WEEKLY_REPORT_PENDING_SUCCESS: "Weekly report updated",
  WEEKLY_REPORT_PENDING_FAILURE: "Weekly report not updated",

  SITE_DIARY_PENDING_SUCCESS: "Site diary updated",
  SITE_DIARY_PENDING_FAILURE: "Site diary not updated",

  SAVED: "Saved",
  NOT_SAVED: "Not Saved",

  ACCOUNT_SUCCESS: "Account Registered",
  ACCOUNT_FAILED: "Account Registration Failed!",
  ACCOUNT_UPDATE_SUCCESS: "Account Updated",
  ACCOUNT_UPDATE_FAILED: "Account Update Failed!",

  BUILDING_ADDED: "Building registered",
  BUILDING_NOT_ADDED: "Building not registered",

  BUILDING_UPDATED: "Building updated",
  BUILDING_NOT_UPDATED: "Building not updated",

  CUSTOMER_SUCCESS: "Customer Registered",
  CUSTOMER_FAILED: "Customer Registration Failed!",
  CUSTOMER_UPDATE_SUCCESS: "Customer Updated",
  CUSTOMER_UPDATE_FAILED: "Customer Update Failed!",

  APARTMENT_NOT_DELETED: "Apartment not deleted",

  SERVICE_SUCCESS: "Service Registered",
  SERVICE_FAILED: "Service Registration Failed!",
  SERVICE_UPDATE_SUCCESS: "Service Updated",
  SERVICE_UPDATE_FAILED: "Service Update Failed!",

  PERMANENT_MANPOWER_SUCCESS: "Permanent Manpower Registered",
  PERMANENT_MANPOWER_FAILED: "Permanent Manpower Registration Failed!",

  REMOVE_SUCCESS: "Successfully Removed!",
  REMOVE_FAILED: "Failed to Remove ",

  UNIT_BREAKDOWN_SUCCESS: "Unit-Breakdown Registered",
  UNIT_BREAKDOWN_FAILED: "Unit-Breakdown Registration Failed!",

  VARIATION_SUCCESS: "Variation Registered",
  VARIATION_FAILED: "Variation Registration Failed!",

  PAYMENT_APPROVAL_SUCCESS: "Payment Approval Successful",
  PAYMENT_APPROVAL_FAILED: "Payment Approval Failed!",

  PAYMENT_REJECT_SUCCESS: "Payment Rejected",
  PAYMENT_REJECT_FAILED: "Failed to Reject",

  PAYMENT_CERTIFICATE_ALREADY_GENERATED: "Payment Already Generated!",

  SUB_CONTRACT_SUCCESS: "Sub Contract Registered!",
  SUB_CONTRACT_FAILED: "Sub Contract Registration Failed!",

  SITE_DIARY_DELETE_SUCCESS: "Site diary deleted",
  SITE_DIARY_DELETE_FAILURE: "Site diary not deleted",

  INVOICE_SUCCESS: "Invoice Registered!",
  INVOICE_FAILED: "Invoice Registration Failed!",

  PAYMENT_SUCCESS: "Revenue Registered!",
  PAYMENT_FAILED: "Revenue Registration Failed!",

  PAYMENT_REMOVE_SUCCESS: "Revenue Removed!",
  PAYMENT_REMOVE_FAILED: "Failed to Remove Revenue",

  CONTRACT_SALES_SUCCESS: "Contract sales added",
  CONTRACT_SALES_FAILED: "Contract sales failed",

  WEEKLY_REPORT_DELETE_SUCCESS: "Weekly report deleted",
  wEEKLY_REPORT_DELETE_FAILURE: "Weekly report not deleted",

  EXPENSE_SUCCESS: "Expense Registered!",
  EXPENSE_FAILED: "Expense Registration Failed!",

  RFI_SUCCESS: "RFI Registered",
  RFI_FAILED: "RFI registration failed",

  RFI_RESPONSE_SUCCESS: "RFI Response Registered",
  RFI_RESPONSE_FAILED: "RFI Response registration failed",

  MEETING_SUCCESS: "Meeting Added!",
  MEETING_FAILED: " Failed to Add Meeting!",

  MEETING_REMOVED_SUCCESS: "Meeting Removed!",
  MEETING_REMOVED_FAILED: "Failed to Remove Meeting!",

  EXPENSE_REMOVE_SUCCESS: "Expense Removed!",
  EXPENSE_REMOVE_FAILED: "Failed to Remove Expense",

  PRICE_ESCALATION_SUCCESS: "Price Escalation Updated!",
  PRICE_ESCALATION_FAILED: "Price Escalation Update Failed!",

  PRICE_ADJUSTMENT_SUCCESS: "Price Adjustment Updated!",
  PRICE_ADJUSTMENT_FAILED: "Price Adjustment Update Failed!",

  DOCUMENT_DOWNLOAD_FAILED: "Document Download Failed!",
  DOCUMENT_REMOVE_SUCCESS: "Document Removed Success!",
  DOCUMENT_REMOVE_FAILED: "Failed to Remove Document!",

  DOCUMENT_UPLOAD_SUCCESS: "Document Upload Success!",
  DOCUMENT_UPLOAD_FAILED: "Failed to Upload Document!",

  SHE_SUCCESS: "SHE successfully added",
  SHE_FAILED: "SHE failed to register",

  DEPARTMENT_SUCCESS: "Department Registered!",
  DEPARTMENT_FAILED: "Failed to Register Department!",

  DEPARTMENT_UPDATE_SUCCESS: "Department Updated!",
  DEPARTMENT_UPDATE_FAILED: "Failed to Update Department!",

  STAFF_SUCCESS: "Staff Registered!",
  STAFF_FAILED: "Failed to  Registered Staff!",

  STAFF_UPDATE_SUCCESS: "Staff Updated!",
  STAFF_UPDATE_FAILED: "Failed to  Update Staff!",

  STAFF_TERMINATED_SUCCESS: "Staff Terminated!",
  STAFF_TERMINATED_FAILURE: "Failed to Terminate Staff!",
  PROJECT_ASSIGNED_SUCCESS: "Project Assigned Successful!",
  PROJECT_ASSIGNED_FAILED: "Project Assignment Failed!",

  EXPORT_FAILED: "Export Failed",
  ADVANCE_BUDGET: "Advance Should be Less then Budget",
  PROJECT_UPDATE_SUCCESS: "Project Update Successful!",
  PROJECT_UPDATE_FAILED: "Project Update Failed!",

  PROJECT_REMOVE_SUCCESS: "Demo Project Removed",
  PROJECT_REMOVE_FAILED: "Failed to Remove Project",

  MANPOWER_OVERTIME_SUCCESS: "Overtime Report Successful!",
  MANPOWER_OVERTIME_FAILED: "Overtime Report Failed!",

  PAYROLL_SUCCESS: "Payroll Registered Successful!",
  PAYROLL_FAILED: "Payroll Registration Failed!",

  PAYROLL_ROLLBACK_SUCCESS: "Payroll Rollback Successful!",
  PAYROLL_ROLLBACK_FAILED: "Payroll Rollback Failed!",

  SCHEDULING_FAILED: "Scheduling Error",

  EMPTY_FIELD: "Empty Field",

  EMPLOYEE_REQUEST_SUCCESS: "Employee Request Registered!",
  EMPLOYEE_REQUEST_FAILED: "Employee Request Registration Failed!",

  MATERIAL_REQUISITION_SUCCESS: "Material Requisition Registered! ",
  MATERIAL_REQUISITION_FAILED: "Material Requisition Registration Failed!",

  PURCHASE_REQUISITION_SUCCESS: "Purchase Requisition Registered! ",
  PURCHASE_REQUISITION_FAILED: "Purchase Requisition Registration Failed!",

  PURCHASE_ORDER_SUCCESS: "Purchase Order Registered! ",
  PURCHASE_ORDER_FAILED: "Purchase Order Registration Failed!",

  PURCHASE_BILLING_SUCCESS: "Purchase Billing Registered!",
  PURCHASE_BILLING_FAILED: "Purchase Billing Registration Failed!",

  GOOD_RECEIVED_SUCCESS: "Good Received Registered!",
  GOOD_RECEIVED_FAILED: "Good Received Registered Failed!",

  GOOD_OUT_SUCCESS: "Good Out Registered!",
  GOOD_OUT_FAILED: "Good Out Registered Failed!",

  PROMOTION_SUCCESS: "Employee Promoted!",
  PROMOTION_FAILED: "Employee Promotion Failed!",

  WORK_ORDER_SUCCESS: "Work Order Registered!",
  WORK_ORDER_FAILED: "Work Order Registration Failed!",

  WORK_ORDER_REMOVE_SUCCESS: "Work Order Removed!",
  WORK_ORDER_REMOVE_FAILED: "Failed to Remove Work Order!",

  ABSENCE_REGISTERED: "Absence Registered!",
  ABSENCE_REGISTRATION_FAILED: "Absence Registration Failed!",
  ABSENCE_REMOVED: "Absence Removed!",
  ABSENCE_REMOVAL_FAILED: "Absence Removal Failed!",
  ABSENCE_ALREADY_REGISTERED: "Can Not Register Absence!",

  HR_POLICY_REGISTERED: "HR Policy Registered!",
  HR_POLICY_REGISTRATION_FAILED: "HR Policy Registration Failed!",
  HR_POLICY_UPDATED: "HR Policy Updated!",
  HR_POLICY_UPDATE_FAILED: "HR Policy Update Failed!",
  HR_POLICY_REMOVED: "HR Policy Removed!",
  HR_POLICY_REMOVAL_FAILED: "HR Policy Removal Failed!",
  HR_POLICY_ALREADY_REGISTERED: "HR Policy Already Registered",

  BENEFIT_REQUEST_REMOVED_SUCCESS: "Benefit Removed!",
  BENEFIT_REQUEST_REMOVED_FAILED: "Failed to Remove!",

  MATERIAL_USAGE_REMOVED_SUCCESS: "Material Usage Removed!",
  MATERIAL_USAGE_REMOVED_FAILED: "Failed to Remove!",

  ALLOWANCE_REGISTERED: "Allowance Registered!",
  ALLOWANCE_REMOVED: "Allowance Removed!",

  ALLOWANCE_REGISTRATION_FAILED: "Failed to Register Allowance!",
  ALLOWANCE_REMOVAL_FAILED: "Failed to Remove!",
  ALLOWANCE_ALREADY_REGISTERED: "Allowance Already Registered",

  EMPLOYEE_ACCOMMODATION_PLAN_SUCCESS: "Employee Accommodation Registered!",
  EMPLOYEE_ACCOMMODATION_PLAN_FAILED:
    "Failed to Register Employee Accommodation!",
  EMPLOYEE_NOT_FOUND: "Employee Not Found!",

  CHECKED_SUCCESS: "Item Checked",
  GENERAL_FAILED: "Action Failed",

  APPROVED_SUCCESS: "Item Approved",
  APPROVED_FAILED: "Approval Failed",

  REVISION_SUCCESS: "Item on revision",
  REVISION_FAILED: "Revision failed",

  ITEM_REMOVED: "Item Removed",

  RESOURCE_SUCCESS: "Resource Registered!",
  RESOURCE_FAILED: "Failed to Register Resource!",

  MATERIAL_REQUISITION_REMOVE_SUCCESS: "Material Requisition Removed!",
  MATERIAL_REQUISITION_REMOVE_FAILED: "Failed to Remove Material Requisition!",
  SIGNATURE_SUCCESS: "Signature Registered!",
  SIGNATURE_FAILED: "Failed to Register Signature!",

  SIGNATURE_REMOVE_SUCCESS: "Signature Removed!",
  SIGNATURE_REMOVE_FAILED: "Failed to Remove Signature!",

  PURCHASE_REQUISITION_REMOVE_SUCCESS: "Purchase Requisition Removed!",
  PURCHASE_REQUISITION_REMOVE_FAILED: "Failed to Remove Purchase Requisition!",

  PURCHASE_ORDER_REMOVE_SUCCESS: "Purchase Order Removed!",
  PURCHASE_ORDER_REMOVE_FAILED: "Failed to Remove Purchase Order!",

  INSPECTION_FORM_SUCCESS: "Inspection Form Registered!",
  INSPECTION_FORM_FAILED: "Failed to Registered Inspection Form!",

  INSPECTION_FORM_EDIT_SUCCESS: "Inspection Form Edited!",
  INSPECTION_FORM_EDIT_FAILED: "Failed to Edit Inspection Form!",

  INSPECTION_FORM_DELETE_SUCCESS: "Inspection Form Deleted!",
  INSPECTION_FORM_DELETE_FAILED: "Failed to Delete Inspection Form!",

  CASTING_FORM_SUCCESS: "Casting Registered!",
  CASTING_FORM_FAILED: "Failed to Register Casting!",

  TEST_FORM_SUCCESS: "Test Registered!",
  TEST_FORM_FAILED: "Failed to Register Test!",

  SUBMITTAL_SUCCESS: "Submittal Registered!",
  SUBMITTAL_FAILED: "Failed to Register Submittal!",

  REMARK_SUCCESS: "Remark Registered!",
  REMARK_FAILED: "Failed to Register Remark!",

  MATERIAL_APPROVAL_SUCCUSS: "Material Request Registered!",
  MATERIAL_APPROVAL_FAILED: "Material Request FAILED!",

  SITE_DIARY_SUCCESS: "Site Diary Registered!",
  SITE_DIARY_FAILURE: "Failed to Register Site Diary!",

  SITE_DIARY_UPDATE_SUCCESS: "Site Diary Updated Successfuly",
  SITE_DIARY_UPDATE_FAILED: "Site Diary Update Failed",

  WEEKLY_REPORT_SUCCESS: "Weekly report registered",
  WEEKLY_REPORT_FAILURE: "Weekly report not added",

  WEEKLY_PROGRESS_SUCCESS: "Weekly progress added successfuly",
  WEEKLY_PROGRESS_FAILURE: "Weekly Progress not added",

  WEEKLY_PROGRESS_UPDATE_SUCCESS: "Weekly Progress update successfuly",
  WEEKLY_PROGRESS_UPDATE_FAILURE: "Weekly Progress update failed",

  QUERY_SUCCESS: "Query Registered!",
  QUERY_FAILED: "Query Failed",

  SHARED_DOCUMENT_SUCCESS: "Document Shared!",
  SHARED_DOCUMENT_FAILED: "Document Sharing Failed!",

  DOCUMENT_STATUS_UPDATE_SUCCESS: "Document Status Updated!",
  DOCUMENT_STATUS_UPDATE_FAILED: "Failed to Update Document Status!",

  ACTION_REGISTERER_SUCCESS: "Item Action Registered",
  ACTION_REGISTERER_FAILED: "Item Action Registration Failed",

  BANK_ACCOUNT_REGISTERED_SUCCESS: "Bank Account Registered!",
  BANK_ACCOUNT_REGISTERED_FAILED: "Bank Account Registration failed!",

  LETTER_REGISTRATION_SUCCESS: "Letter Registered!",
  LETTER_REGISTRATION_FAILED: "Failed to Register Letter",

  USER_ASSIGNED_SUCCESS: "User Assigned!",
  USER_ASSIGNED_FAILED: "Failed to Assign User!",

  REJECT_SUCCESS: "Report Rejected!",
  REJECT_FAILED: "Failed to Reject Report!",
  CONTRACT_REGISTERED_SUCCESS: "Contract Registered!",
  CONTRACT_REGISTERED_FAILED: "Failed to Register Contract!",

  RECEIVABLE_REGISTRATION_SUCCESS: "Receivable Registered!",
  RECEIVABLE_REGISTRATION_FAILED: "Failed to Register Receivable!",

  ATTACHMENT_REGISTRATION_SUCCESS: "Attachment Registered!",
  ATTACHMENT_REGISTRATION_FAILED: "Failed to Register Attachment",

  PETTY_CASH_REGISTRATION_SUCCESS: "Petty Cash Registered!",
  PETTY_CASH_REGISTRATION_FAILED: "Failed to Register Petty Cash",

  REPLENISHMENT_TRANSACTION_REGISTRATION_SUCCESS: "Transaction Registered!",
  REPLENISHMENT_TRANSACTION_REGISTRATION_FAILED:
    "Failed to Register Transaction",

  REQUEST_REPLENISHMENT_REGISTRATION_SUCCESS:
    "Request Replenishment Registered!",
  REQUEST_REPLENISHMENT_REGISTRATION_FAILED: "Failed to Request Replenishment",

  POST_CHECK_REGISTRATION_SUCCESS: "Post Check Registered!",
  POST_CHECK_REGISTRATION_FAILED: "Failed to Register Post Check",

  POST_CHECK_CASHED_OUT_SUCCESS: "Post Check Cashed Out!",
  POST_CHECK_CASHED_OUT_FAILED: "Failed to Cash Out Post Check",

  POST_CHECK_Drop_SUCCESS: "Post Check Dropped!",
  POST_CHECK_Drop_FAILED: "Failed to Drop Post Check",

  CRV_PAYMENT_REMOVE_SUCCESS: "CRV Payment removed",
  CRV_PAYMENT_REMOVE_FAILED: "Failed to remove CRV Payment",

  DAILY_REPORT_SUCCESS: "Daily Report Registered!",
  DAILY_REPORT_FAILED: "Failed to Register Daily Report",

  NO_CHANGE_TO_SAVE: "No change to save",

  CASTING_UPDATE_SUCCESS: "Casting updated!",
  CASTING_UPDATE_FAIL: "Failed to update Casting",

  CASTING_DELETE_SUCCESS: "Casting deleted!",
  CASTING_DELETE_FAILED: "Failed to delete Casting",

  INSPECTION_REQUEST_UPDATE_SUCCESS: "Inspection updated!",
  INSPECTION_REQUEST_UPDATE_FAILED: "Failed to update Inspection",

  INSPECTION_REQUEST_DELETE_SUCCESS: "Inspection deleted!",
  INSPECTION_REQUEST_DELETE_FAILED: "Failed to delete Inspection",

  TEST_RESULT_UPDATE_SUCCESS: "Test Result updated successfully!",
  TEST_RESULT_UPDATE_FAILED: "Failed to update Test Result update",

  TEST_RESULT_DELETE_SUCCESS: "Test Result deleted successfully!",
  TEST_RESULT_DELETE_FAIL: "Failed to delete Test Result",

  CASTING_TEST_REPORT_SUCCESS: "Casting Test Report registered!",
  CASTING_TEST_REPORT_FAILED: "Failed to Register Casting Test Report",

  CASTING_TEST_REPORT_UPDATE_SUCCESS: "Casting Test Report updated!",
  CASTING_TEST_REPORT_UPDATE_FAILED: "Failed to Update Casting Test Report",

  CASTING_TEST_REPORT_DELETE_SUCCESS: "Casting Test Report deleted!",
  CASTING_TEST_REPORT_DELETE_FAILED: "Failed to Delete Casting Test Report",

  SHARED_DOCUMENT_DELETE_SUCCESS: "Document Share Deleted!",
  SHARED_DOCUMENT_DELETE_FAILED: "Failed to Delete Document Sharing!",
};

export const PURCHASE_BILLING_TYPES = ["Material", "Service"] as const;
export type PurchaseBillingType = "Material" | "Service";

export const PURCHASE_BILLING_SUCCESS = "Purchase Billing Registered!";
export const PURCHASE_BILLING_FAILED = "Purchase Billing Registration Failed!";

export const UsageReportType = {
  DAILY: "Daily",
  RANGE: "Range",
  DOWN_TIME: "Down Time",
  MAINTENANCE: "Maintenance",
};

export const MasterScheduleActions = {
  APPROVER: "Approver",
  REPORTER: "Reporter",
};
export const PAYMENT_TYPE = [
  "Interim PC",
  "Penultimate Certificate",
  "Final Certificate",
  "Variation Certificate",
  "Certificate of Practical completion",
  "Certificate of Making good defects",
  "Certificate of non-completion",
];

export const Status = {
  PENDING: 0,
  APPROVED: 1,
  REVISE: 2,
};

export const LetterType = {
  NEW: "New",
  RESPONSE: "Response",
};
export const TransferMode = {
  LAND: "Land",
  AIR: "Air",
};

export const StaffStatus = {
  ACTIVE: "Active",
  TERMINATED: "Terminated",
};

export const GoodReceivedType = {
  PURCHASES: "Purchase",
  TRANSFER: "Transfer",
  RENT: "Rent",
  REQUESTED: "Requested",
  ASSET: "Asset",
};

export const StaffType = {
  PERMANENT: "Permanent",
  TEMPORARY: "Temporary",
};

export const ResourceType = {
  STAFF: "Staff",
  LABOUR: "Labour",
  EQUIPMENT: "Equipment",
  VEHICLE: "Vehicle",
  MATERIAL: "Material",
};

export const StaffReportType = {
  EMPLOYEE: "Employee",
  PAYROLL: "Payroll",
  ATTENDANCE: "Attendance",
  LEAVE: "Leave",
  OVERTIME: "Overtime",
  LOAN: "Loan",
};

export const CashFlowTabs = {
  SUMMARY: "Summary",
  DETAIL: "Detail",
};

interface States {
  [state: number]: number; //indexer
}

export const WeightRebar: States = {
  6: 0.22,
  8: 0.395,
  10: 0.617,
  12: 0.888,
  14: 1.208,
  16: 1.58,
  20: 2.47,
  24: 3.55,
  32: 5.3,
};

export const REBAR_LENGTH = 12;

export const OvertimeMultiplier = {
  HOLIDAY: {
    multiplier: 2.5,
    start_time: moment("00:00", "h:mm"),
    end_time: moment("24:00", "h:mm"),
  },
  SUNDAY: {
    multiplier: 2,
    start_time: moment("00:00", "h:mm"),
    end_time: moment("24:00", "h:mm"),
  },
  SATURDAY: {
    multiplier: 2,
    start_time: moment("12:00", "h:mm"),
    end_time: moment("24:00", "h:mm"),
  },
  DAY_OVERTIME: {
    multiplier: 1.5,
    start_time: moment("6:00", "h:mm"),
    end_time: moment("21:00", "h:mm"),
  },
  NIGHT_OVERTIME: {
    multiplier: 1.75,
    start_time_night: moment("21:00", "h:mm"),
    end_time_night: moment("24:00", "h:mm"),
    start_time_day: moment("00:00", "h:mm"),
    end_time_day: moment("6:00", "h:mm"),
  },
};

export const AttendanceUserType = {
  SIGNING: "Signing",
  NON_SIGNING: "Non-Signing",
};

export const UserTabs = {
  USER_MATRIX: "User Matrix",
  USER_REGISTRATION: "User Registration",
};

export const UNITS = [
  { name: "M", value: "m", type: "length" },
  { name: "M²", value: "m2", type: "area" },
  { name: "M³", value: "m3", type: "volume" },
  { name: "KM", value: "km", type: "length" },
  { name: "KG", value: "kg", type: "mass" },
  { name: "Lt.", value: "l", type: "volume" },
  { name: "ML", value: "ml", type: "volume" },
  { name: "PCS", value: "pcs", type: "no" },
  { name: "Berga", value: "berga", type: "no" },
  { name: "Nº", value: "no", type: "no" },
  { name: "Quintal", value: "quintal", type: "mass" },
  { name: "Ton", value: "ton", type: "mass" },
  { name: "Packet", value: "pkt", type: "mass" },
  { name: "Roll", value: "roll", type: "mass" },
  { name: "Gallon", value: "gallon", type: "no" },
  { name: "Set", value: "set", type: "no" },
  { name: "Kilowatts", value: "kilowatts", type: "no" },
];

export const COMPANY_CATEGORY = [
  "Contractor",
  "Consultant",
  "Real-Estate Developer",
  "Freelance",
];

export const ETHIOPIAN_MONTHS = [
  "መስከረም",
  "ጥቅምት",
  "ኅዳር",
  "ታኅሣሥ",
  "ጥር",
  "የካቲት",
  "መጋቢት",
  "ሚያዝያ",
  "ግንቦት",
  "ሰኔ",
  "ሐምሌ",
  "ነሐሴ",
  "ጳጉሜ",
];

export const ConversionRate: any = {
  g: {
    g: 1,
    kg: 0.001,
    quintal: 0.0001,
    ton: 0.000001,
  },
  kg: {
    g: 1000,
    kg: 1,
    quintal: 0.01,
    ton: 0.001,
  },
  quintal: {
    g: 100000,
    kg: 100,
    quintal: 1,
    ton: 0.1,
  },
  ton: {
    g: 1000000,
    kg: 1000,
    quintal: 100,
    ton: 1,
  },
};

export const ValidationStatus = {
  ERROR: "error",
  VALIDATING: "validating",
};
export const ItemCategory = {
  CONSTRUCTION_MATERIAL: "Construction Material",
  CONSTRUCTION_EQUIPMENT: "Construction Equipment",
  VEHICLE: "Vehicle",
  FURNITURE: "Furniture",
  SPARE_PART: "Spare Part",
  FIXED_ASSET: "Fixed Asset",
};

export const PriorityType = {
  HIGH: "High",
  MEDIUM: "Medium",
  LOW: "Low",
};
export const MeetingType = {
  REGULAR_WEEKLY: "Regular Weekly",
  REGULAR_BIWEEKLY: "Regular Biweekly",
  REGULAR_MONTHLY: "Regular Monthly",
  REGULAR_QUARTERLY: "Regular Quarterly",
  REGULAR_ANNUAL: "Regular Annual",
};

export const MATERIAL_LIST = [
  "Ceramic Product",
  "Cement Product",
  "Electrical Material",
  "Explosive",
  "Gas & Bottles Accessories",
  "Glass Material",
  "Gravel and Selected Material",
  "Iron Bar",
  "Laboratory Material",
  "Metallic Product",
  "Plastic Product",
  "Plumbing & Sanitary Materials",
  "Painting Material",
  "Wooden Material",
];

export const EQUIPMENT_LIST = [
  " Asphalt Batching Plant",
  "Generator",
  "Air Compressor",
  "Tower Cranes",
  "Pile Boring Machine",
  "Pile Driving Machine",
];

export const ACCOUNT_TYPES = [
  "Accounts Payable",
  "Accounts Receivable",
  "Accumulated Deprecation",
  "Cash",
  "Cost of Sales",
  "Equity-doesn't close",
  "Equity-Retained Earnings",
  "Expenses",
  "Fixed Assets",
  "Income",
  "Inventory",
  "Long Term Liabilities",
  "Other Assets",
];
export const VEHICLE_LIST = [
  "Backhoe",
  "Bulldozers",
  "Dragline Excavator",
  "Dozer",
  "Excavator",
  "Roller",
  "Grader",
  "Asphalt Paver",
  "Water Truck",
  "Asphalt Truck",
  "Pick up",
  "Fuel Truck",
  "Lowbed",
  "Small Vehicle",
  "Pneumatic Tyred Roller",
  "Double Drum Steel Roller",
  "Loader",
  "Asphalt Distributor",
  "Wheel Tractor Scraper",
  "Pavers",
  "Feller Bunchers",
  "Dump Trucks",
];

export const DEPARTMENT = [
  "Engineering",
  "Construction",
  "Equipment Maintenance",
  "Project administration",
  "Health and Safety",
  "Equipment",
];

export const HeaderType = {
  DESCRIPTION: "Description",
  DATA: "Data",
  TOTAL: "Total",
};

export const VariationType = {
  NEW: "New",
  UPDATE: "Update",
  REPORT: "Report",
};

export const PaymentMethod = {
  CASH: "Cash",
  CHECK: "Check",
  BANK_TRANSACTION: "Bank Transaction",
};

export const DOCUMENT_TYPE = [
  "Resume",
  "Education Document",
  "Employment verification",
  "letters",
  "Tax RecordsMedical Document",
  "Promotion Request",
  "Government Id",
  "Location Map",
  "Feasibility and Analysis",
  "Cost Document",
  "Contract Document",
  "Electrical Design",
  "Structural Design",
  "Sanitary Design",
  "Architectural Design",
  "Site Diary",
  "Inspection",
  "Claim And Variation",
  "Payroll",
  "Labour Time-Sheet",
  "Equipment Time-Sheet",
  "Photo",
  "Monthly Progress Report",
  "Design Modifications",
  "Carta",
  "Legal Documents",
  "Site Book",
  "Other",
];

export const GeneralWorkProgress = ["Completed", "Ongoing", "Planned"];

export const VAT = 1.15;
export const INCOME_TAX = 1.15;

export const TAX_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'vat_15', label: 'VAT 15%' },
  { value: 'tot_10', label: 'TOT 10%' },
] as const;

export const TAX_RATES = {
  none: 0,
  vat_15: 0.15,
  tot_10: 0.10,
} as const;

export const WITHHOLD_RATE = 0.03;

export type TaxType = 'none' | 'vat_15' | 'tot_10';

export const TOUR_DELAY = 1000;

export const ALLOWED_FILE_SIZE = 104860000;

export const COMPANY_PENSION = 1.11;
export const EMPLOYEE_PENSION = 1.07;

export const OVERTIME = 1.2;
export const ONGOING = "OnGoing";
export const STALLED = "Stalled";
export const FINISHED = "Finished";
export const EXPECTED_ADJUSTMENT = 1.08;
export const OVERHEAD_EXPENSE = 1.1;
export const OTHER_EXPENSE = 1.05;
export const LESS_WITH_HOLDING_TAX = 1.02;
export const FUEL_RATE = 25.8;
export const WITH_HOLD = 1.02;

export const AMORTIZATION_EXPENSE = "Amortization Expense";
export const BAD_DEBTS = "Bad Debts";
export const BANK_CHARGES = "Bank Charges";
export const COMMISSIONS_AND_FEES = "Commissions & Fees";
export const DUES_AND_SUBSCRIPTION = "Dues & Subscriptions";
export const EQUIPMENT_RENTAL = "Equipment Rental";
export const INCOME_TAX_EXPENSE = "Income Tax Expense";
export const INSURANCE_DISABILITY = "Insurance - Disability";
export const INSURANCE_GENERAL = "Insurance - General";
export const INSURANCE_LIABILITY = "Insurance - Liability";
export const INTEREST_EXPENSE = "Interest Expense";
export const LEGAL_AND_PROFESSIONAL_FEES = "Legal & Professional Fees";
export const LOSS_ON_DISCONTINUED =
  "Loss on Discontinued Operations, Net of Tax";
export const MANAGEMENT_COMPENSATION = "Management Compensation";
export const MEALS_AND_ENTERTAINMENT = "Meals & Entertainment";
export const OFFICE_EXPENSES = "Office Expense";
export const OTHER_GENERAL_AND_ADMINISTRATIVE_EXPENSE =
  "Other General & Administrative Expenses";
export const OTHER_SELLING_EXPENSE = "Other Selling Expenses";
export const OTHER_TYPE_OF_EXPENSE_ADVERTISING_EXPENSES =
  "Other Types of Expenses-Advertising Expenses";
export const PAYROLL_EXPENSES = "Payroll Expenses";
export const PURCHASES = "Purchases";
export const RENT_OR_LEASE_PAYMENTS = "Rent or Lease Payments";
export const REPAIRS_AND_MAINTENANCE = "Repairs & Maintenance";
export const SHIPPING_AND_DELIVERY_EXPENSE = "Shipping & Delivery Expense";
export const STATIONERY_AND_PRINTING = "Stationery & Printing";
export const SUPPLIES = "Supplies";
export const TRAVEL_EXPENSES_GENERAL_AND_ADMIN_EXPENSES =
  "Travel Expenses - General & Admin Expenses";
export const TRAVEL_EXPENSES_SELLING_EXPENSES =
  "Travel Expenses - Selling Expenses";
export const UNCATEGORIZED_EXPENSE = "Uncategorized Expense";
export const UTILITIES = "Utilities";
export const WAGE_EXPENSES = "Wage Expenses";

export const CASH_AND_CASH_EQUIVALENTS = "Cash & Cash Equivalents";
export const FUEL_EXPENSE = "Fuel Expense";
export const ALLOWANCE_FOR_BAD_DEBT = "Allowance for Bad Debt";
export const AVAILABLE_FOR_SALE_ASSETS =
  "Available for sale assets (short-term)";
export const INVENTORY = "Inventory";
export const INVENTORY_ASSET = "Inventory Asset";
export const PREPAID_EXPENSE = "Prepaid expenses";
export const UNCATEGORIZED_ASSET = "Uncategorized Asset";
export const UNDEPOSITED_FUND = "Undeposited Funds";

export const ACCUMULATED_DEPRECIATION_ON_PROPERTY =
  "Accumulated Depreciation on Property, Plant & Equipment";
export const PROPERTY_PLANT_AND_EQUIPMENT = "Property, Plant & Equipment";

export const ASSETS_HELD_FOR_SALE = "Assets Held for Sale";
export const DEFERRED_TAX_ASSETS = "Deferred Tax Assets";
export const GOODWILL = "Goodwill";
export const INTANGIBLES = "Intangibles";
export const LONG_TERM_INVESTMENTS = "Long-Term Investments";

export const ACCRUED_LIABILITY = "Accrued Liabilities";
export const DIVIDENDS_PAYABLE = "Dividends Payable";
export const INCOME_TAX_PAYABLE = "Income Tax Payable";
export const PAYROLL_CLEARING = "Payroll Clearing";
export const PAYROLL_LIABILITIES = "Payroll Liabilities";
export const SHORT_TERM_DEBIT = "Short-Term Debit";

export const ACCRUED_HOLIDAY_PAYABLE = "Accrued Holiday Payable";
export const ACCRUED_NON_CURRENT_LIABILITIES =
  "Accrued Non-Current Liabilities";
export const LIABILITIES_RELATED_TO_ASSETS_HELD_FOR_SALE =
  "Liabilities Related To Assets Held For Sale";
export const LONG_TERM_DEBT = "Long-Term Debt";

export const DIVIDEND_DISBURSED = "Dividend Disbursed";
export const EQUITY_IN_EARNINGS_OF_SUBSIDIARIES =
  "Equity in Earnings of Subsidiaries";
export const OTHER_COMPREHENSIVE_INCOME = "Other Comprehensive Income";
export const RETAINED_EARNINGS = "Retained Earnings";
export const SHARE_CAPITAL = "Share Capital";

export const BILLABLE_EXPENSE_INCOME = "Billable Expense Income";
export const REVENUE_GENERAL = "Revenue - General";
export const SALES = "Sales";
export const SALES_RETAIL = "Sales - Retail";
export const SALES_WHOLESALE = "Sales - Wholesale";
export const SALES_OF_PRODUCT_INCOME = "Sales of Product Income";
export const UNCATEGORIZED_INCOME = "Uncategorised Income";

export const CHANGE_IN_INVENTORY_COS = "Change in Inventory - COS";
export const COST_OF_SALES = "Cost of Sales";
export const DIRECT_LABOUR_COS = "Direct Labour - COS";
export const DISCOUNT_GIVEN_COS = "Discounts Given - COS";
export const FREIGHT_AND_DELIVERY_COS = "Freight and Delivery - COS";
export const MATERIAL_COS = "Materials - COS";
export const OTHER_COS = "Other - COS";
export const SUBCONTRACTOR_COS = "Subcontractors - COS";

export const DIVIDEND_INCOME = "Dividend Income";
export const INTEREST_INCOME = "Interest Income";
export const LOSS_ON_DISPOSAL_OF_ASSETS = "Loss on Disposal of Assets";
export const OTHER_OPERATING_INCOME = "Other Operating Income (Expenses)";
export const UNREALIZED_LOSS_ON_SECURITIES =
  "Unrealized Loss on Securities, Net of Tax";
export const RECONCILIATION_DISCREPANCIES = "Reconciliation Discrepancies";

export const TRAVEL_REQUEST = "travel_request";
export const BENEFIT_REQUEST = "benefit_request";
export const LEAVE_REQUEST = "leave_request";
export const OVERTIME_REQUEST = "overtime_request";

export const CONSTRUCTION_MATERIAL = "Construction Material";
export const CONSTRUCTION_EQUIPMENT = "Construction Equipment";
export const VEHICLE = "Vehicle";

export const AGRICULTURE = "Agriculture";
export const FUEL_OIL_LIBRATION = "Fuel,Oil & Lubrication";
export const OTHER_MATERIAL = "Other Material";
export const OFFICE_SUPPLIES = "Office Supplies";
export const FURNITURE = "Furniture";
export const SPARE_PART = "Spare-Part";
export const SUBCONTRACTOR_LABOUR = "Subcontractors Labour";
export const SUBCONTRACTOR_FIXED_AND_SUPPLY = "Subcontractors Fixed and Supply";

export const RENT = "Administrative Rent";
export const ADMINISTRATIVE_UNITIES = "Administrative Utilities";
export const ADMINISTRATIVE_INSURANCE = "Administrative Insurance";
export const EXECUTIVE_WAGES = "Executives wages and Benefits";
export const DEPRECATION_ON_OFFICE =
  "The Deprecation on Office fixtures and Equipment";
export const LEGAL_COUNSEL_AND_ACCOUNTING_STAFF_SALARIES =
  "Legal Counsel and Accounting Staff Salary";

export const DASHBOARD_STEPS = (name: string) => [
  {
    target: ".body",
    title: `Hello ${name}`,
    content: "Welcome to Condigital Enterprise.",
    disableBeacon: true,
  },
  {
    target: ".show_tip",
    content:
      "Here you can find introductory information to help you through journey with ConDigital Platform.",
    disableBeacon: false,
  },
];

export const PROJECT_STEPS = [
  {
    target: ".project_list_table",
    title: "Project List",
    content:
      "In this Page projects under your supervision are listed with summarized information defining them. Click View Project button to view more information about your project.",
    disableBeacon: true,
  },
];
export const REGISTER_PROJECT_STEP = [
  {
    target: ".register_project",
    title: "Register Project",
    content:
      "You can register projects by 1. Registering basic information and contract finance data 2. By registering the projects Bill of Quanitites.",
    disableBeacon: true,
  },
];
export const PROJECT_TAB_STEPS = [
  {
    target: ".plan_tab",
    title: "Project Detail",
    content:
      "Here you can find planning, execution and evaluation data about your project. Use the menu to view each aspect of the project lifecycle",
    disableBeacon: true,
  },
];
export const DOCUMENT_STEP = [
  {
    target: ".document",
    title: "Document",
    content:
      "Here you can upload, categorically store files and documents under your project. You can upload Pdf, Excel, AutoCAD files, Images, Videos",
    disableBeacon: true,
  },
];
export const REPORT_STEP = [
  {
    target: ".report",
    title: "Report",
    content:
      "Register progress, variation and expense on the projects you supervise. Use the designed takeoff templates to report detailed data regarding the project.",
    disableBeacon: true,
  },
];
export const PROCUREMENT_STEP = [
  {
    target: ".procurement",
    title: "Procurement",
    content:
      "Manage Material or Purchase requisitions along with generating purchase order to be submitted to suppliers.",
    disableBeacon: true,
  },
];
export const FINANCE_STEP = [
  {
    target: ".finance",
    title: "Finance",
    content:
      "Manage your Project and Company Finance transactions grouped into payments and expenses. Summarized and Detailed reports are also provided to give you accurate financial performance of your enterprise.",
    disableBeacon: true,
  },
];
export const INVENTORY_STEP = [
  {
    target: ".inventory",
    title: "Inventory",
    content:
      "Manage you material inventory be registering purchase, transfer and usage.",
    disableBeacon: true,
  },
];
export const FIXED_ASSET_STEP = [
  {
    target: ".fixed_asset",
    title: "Fixed Asset",
    content:
      "Register and manager your fixed assets like vehicles and Equipment.",
    disableBeacon: true,
  },
];
export const HR_STEP = [
  {
    target: ".hr",
    title: "Human Resource",
    content: "Hire, assign and generate payroll for your Human resources.",
    disableBeacon: true,
  },
];
export const SIDE_MENU = [
  {
    target: ".project_list_table",
    content: "We accept returns after 14 days max",
    disableBeacon: true,
  },
];

export const TAKEOFF_STEPS = [
  {
    target: ".item_selector",
    content:
      "Please select an item from the contract BoQ you want to report on",
    disableBeacon: true,
  },
  {
    target: ".sheet_tab",
    content: "You can add take off Sheets here Multiple Sheets",
    disableBeacon: true,
  },
];

export const DOCUMENT_WORK_ORDER_TYPE = [
  "Review",
  "Approve",
  "Action Submittal",
  "Information Submittal",
];

export const EXPENSE_TYPES = [
  BAD_DEBTS,
  BANK_CHARGES,
  CASH_AND_CASH_EQUIVALENTS,
  COMMISSIONS_AND_FEES,
  DUES_AND_SUBSCRIPTION,
  EQUIPMENT_RENTAL,
  INCOME_TAX_EXPENSE,
  INSURANCE_DISABILITY,
  INSURANCE_GENERAL,
  INTEREST_EXPENSE,
  LEGAL_AND_PROFESSIONAL_FEES,
  LOSS_ON_DISCONTINUED,
  MANAGEMENT_COMPENSATION,
  MEALS_AND_ENTERTAINMENT,
  OFFICE_EXPENSES,
  OTHER_GENERAL_AND_ADMINISTRATIVE_EXPENSE,
  OTHER_SELLING_EXPENSE,
  OTHER_TYPE_OF_EXPENSE_ADVERTISING_EXPENSES,
  PAYROLL_EXPENSES,
  PURCHASES,
  RENT_OR_LEASE_PAYMENTS,
  REPAIRS_AND_MAINTENANCE,
  SHIPPING_AND_DELIVERY_EXPENSE,
  STATIONERY_AND_PRINTING,
  SUPPLIES,
  TRAVEL_EXPENSES_GENERAL_AND_ADMIN_EXPENSES,
  TRAVEL_EXPENSES_SELLING_EXPENSES,
  UNCATEGORIZED_EXPENSE,
  UTILITIES,
  WAGE_EXPENSES,
  ALLOWANCE_FOR_BAD_DEBT,
  UNDEPOSITED_FUND,
  UNCATEGORIZED_ASSET,
  PREPAID_EXPENSE,
  INVENTORY_ASSET,
  INVENTORY,
  AVAILABLE_FOR_SALE_ASSETS,
  SUBCONTRACTOR_COS,
  OTHER_COS,
  MATERIAL_COS,
  FREIGHT_AND_DELIVERY_COS,
  DISCOUNT_GIVEN_COS,
  DIRECT_LABOUR_COS,
  COST_OF_SALES,
  CHANGE_IN_INVENTORY_COS,
  SHARE_CAPITAL,
  RETAINED_EARNINGS,
  OTHER_COMPREHENSIVE_INCOME,
  EQUITY_IN_EARNINGS_OF_SUBSIDIARIES,
  DIVIDEND_DISBURSED,
  LONG_TERM_DEBT,
  LIABILITIES_RELATED_TO_ASSETS_HELD_FOR_SALE,
  ACCRUED_NON_CURRENT_LIABILITIES,
  ACCRUED_HOLIDAY_PAYABLE,
  SHORT_TERM_DEBIT,
  PAYROLL_LIABILITIES,
  PAYROLL_CLEARING,
  INCOME_TAX_PAYABLE,
  DIVIDENDS_PAYABLE,
  ACCRUED_LIABILITY,
  LONG_TERM_INVESTMENTS,
  INTANGIBLES,
  GOODWILL,
  DEFERRED_TAX_ASSETS,
  ASSETS_HELD_FOR_SALE,
  PROPERTY_PLANT_AND_EQUIPMENT,
  ACCUMULATED_DEPRECIATION_ON_PROPERTY,
  INSURANCE_LIABILITY,
  AMORTIZATION_EXPENSE,
  FUEL_EXPENSE,
];

export const PEData = [
  {
    position: "Project Manager",
    no: 1,
    description: "",
    noo: 0,
    workedHours: 0,
    idleHour: 0,
    downHours: 0,
  },
  {
    position: "Office Engineer",
    no: 1,
    description: "",
    noo: 0,
    workedHours: 0,
    idleHour: 0,
    downHours: 0,
  },
  {
    position: "Site Engineer",
    no: 1,
    description: "",
    noo: 0,
    workedHours: 0,
    idleHour: 0,
    downHours: 0,
  },
  {
    position: "General Foreman",
    no: 1,
    description: "",
    noo: 0,
    workedHours: 0,
    idleHour: 0,
    downHours: 0,
  },
  {
    position: "Casher",
    no: 1,
    description: "",
    noo: 0,
    workedHours: 0,
    idleHour: 0,
    downHours: 0,
  },
  {
    position: "Project Administration",
    no: 1,
    description: "",
    noo: 0,
    workedHours: 0,
    idleHour: 0,
    downHours: 0,
  },
  {
    position: "Time & Store Keeper",
    no: 1,
    description: "",
    noo: 0,
    workedHours: 0,
    idleHour: 0,
    downHours: 0,
  },
];

export const LIST_OF_COUNTRIES = [
  { name: "Afghanistan", code: "AF" },
  { name: "Åland Islands", code: "AX" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "American Samoa", code: "AS" },
  { name: "AndorrA", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctica", code: "AQ" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bermuda", code: "BM" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Bouvet Island", code: "BV" },
  { name: "Brazil", code: "BR" },
  { name: "British Indian Ocean Territory", code: "IO" },
  { name: "Brunei Darussalam", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Cape Verde", code: "CV" },
  { name: "Cayman Islands", code: "KY" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cocos (Keeling) Islands", code: "CC" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo", code: "CG" },
  { name: "Congo, The Democratic Republic of the", code: "CD" },
  { name: "Cook Islands", code: "CK" },
  { name: "Costa Rica", code: "CR" },
  { name: "Cote D'Ivoire", code: "CI" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Ethiopia", code: "ET" },
  { name: "Falkland Islands (Malvinas)", code: "FK" },
  { name: "Faroe Islands", code: "FO" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "French Guiana", code: "GF" },
  { name: "French Polynesia", code: "PF" },
  { name: "French Southern Territories", code: "TF" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greece", code: "GR" },
  { name: "Greenland", code: "GL" },
  { name: "Grenada", code: "GD" },
  { name: "Guadeloupe", code: "GP" },
  { name: "Guam", code: "GU" },
  { name: "Guatemala", code: "GT" },
  { name: "Guernsey", code: "GG" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Heard Island and Mcdonald Islands", code: "HM" },
  { name: "Holy See (Vatican City State)", code: "VA" },
  { name: "Honduras", code: "HN" },
  { name: "Hong Kong", code: "HK" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran, Islamic Republic Of", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Isle of Man", code: "IM" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jersey", code: "JE" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: "Korea, Democratic People'S Republic of", code: "KP" },
  { name: "Korea, Republic of", code: "KR" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: "Lao People'S Democratic Republic", code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libyan Arab Jamahiriya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Macao", code: "MO" },
  { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Martinique", code: "MQ" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mayotte", code: "YT" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia, Federated States of", code: "FM" },
  { name: "Moldova, Republic of", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montserrat", code: "MS" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "Netherlands Antilles", code: "AN" },
  { name: "New Caledonia", code: "NC" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "Niue", code: "NU" },
  { name: "Norfolk Island", code: "NF" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestinian Territory, Occupied", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Pitcairn", code: "PN" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Qatar", code: "QA" },
  { name: "Reunion", code: "RE" },
  { name: "Romania", code: "RO" },
  { name: "Russian Federation", code: "RU" },
  { name: "RWANDA", code: "RW" },
  { name: "Saint Helena", code: "SH" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Pierre and Miquelon", code: "PM" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia and Montenegro", code: "CS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Svalbard and Jan Mayen", code: "SJ" },
  { name: "Swaziland", code: "SZ" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syrian Arab Republic", code: "SY" },
  { name: "Taiwan, Province of China", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania, United Republic of", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tokelau", code: "TK" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Turks and Caicos Islands", code: "TC" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "United States Minor Outlying Islands", code: "UM" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Venezuela", code: "VE" },
  { name: "Viet Nam", code: "VN" },
  { name: "Virgin Islands, British", code: "VG" },
  { name: "Virgin Islands, U.S.", code: "VI" },
  { name: "Wallis and Futuna", code: "WF" },
  { name: "Western Sahara", code: "EH" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" },
];

export const CURRENCY_LIST = [
  {
    code: "AED",
    description: "United Arab Emirates Dirham",
  },
  {
    code: "AFN",
    description: "Afghan Afghani**",
  },
  {
    code: "ALL",
    description: "Albanian Lek",
  },
  {
    code: "AMD",
    description: "Armenian Dram",
  },
  {
    code: "ANG",
    description: "Netherlands Antillean Gulden",
  },
  {
    code: "AOA",
    description: "Angolan Kwanza**",
  },
  {
    code: "ARS",
    description: "Argentine Peso**",
  },
  {
    code: "AUD",
    description: "Australian Dollar",
  },
  {
    code: "AWG",
    description: "Aruban Florin",
  },
  {
    code: "AZN",
    description: "Azerbaijani Manat",
  },
  {
    code: "BAM",
    description: "Bosnia & Herzegovina Convertible Mark",
  },
  {
    code: "BBD",
    description: "Barbadian Dollar",
  },
  {
    code: "BDT",
    description: "Bangladeshi Taka",
  },
  {
    code: "BGN",
    description: "Bulgarian Lev",
  },
  {
    code: "BIF",
    description: "Burundian Franc",
  },
  {
    code: "BMD",
    description: "Bermudian Dollar",
  },
  {
    code: "BND",
    description: "Brunei Dollar",
  },
  {
    code: "BOB",
    description: "Bolivian Boliviano**",
  },
  {
    code: "BRL",
    description: "Brazilian Real**",
  },
  {
    code: "BSD",
    description: "Bahamian Dollar",
  },
  {
    code: "BWP",
    description: "Botswana Pula",
  },
  {
    code: "BZD",
    description: "Belize Dollar",
  },
  {
    code: "CAD",
    description: "Canadian Dollar",
  },
  {
    code: "CDF",
    description: "Congolese Franc",
  },
  {
    code: "CHF",
    description: "Swiss Franc",
  },
  {
    code: "CLP",
    description: "Chilean Peso**",
  },
  {
    code: "CNY",
    description: "Chinese Renminbi Yuan",
  },
  {
    code: "COP",
    description: "Colombian Peso**",
  },
  {
    code: "CRC",
    description: "Costa Rican Colón**",
  },
  {
    code: "CVE",
    description: "Cape Verdean Escudo**",
  },
  {
    code: "CZK",
    description: "Czech Koruna**",
  },
  {
    code: "DJF",
    description: "Djiboutian Franc**",
  },
  {
    code: "DKK",
    description: "Danish Krone",
  },
  {
    code: "DOP",
    description: "Dominican Peso",
  },
  {
    code: "DZD",
    description: "Algerian Dinar",
  },
  {
    code: "EGP",
    description: "Egyptian Pound",
  },
  {
    code: "ETB",
    description: "Ethiopian Birr",
  },
  {
    code: "EUR",
    description: "Euro",
  },
  {
    code: "FJD",
    description: "Fijian Dollar",
  },
  {
    code: "FKP",
    description: "Falkland Islands Pound**",
  },
  {
    code: "GBP",
    description: "British Pound",
  },
  {
    code: "GEL",
    description: "Georgian Lari",
  },
  {
    code: "GIP",
    description: "Gibraltar Pound",
  },
  {
    code: "GMD",
    description: "Gambian Dalasi",
  },
  {
    code: "GNF",
    description: "Guinean Franc**",
  },
  {
    code: "GTQ",
    description: "Guatemalan Quetzal**",
  },
  {
    code: "GYD",
    description: "Guyanese Dollar",
  },
  {
    code: "HKD",
    description: "Hong Kong Dollar",
  },
  {
    code: "HNL",
    description: "Honduran Lempira**",
  },
  {
    code: "HRK",
    description: "Croatian Kuna",
  },
  {
    code: "HTG",
    description: "Haitian Gourde",
  },
  {
    code: "HUF",
    description: "Hungarian Forint**",
  },
  {
    code: "IDR",
    description: "Indonesian Rupiah",
  },
  {
    code: "ILS",
    description: "Israeli New Sheqel",
  },
  {
    code: "INR",
    description: "Indian Rupee**",
  },
  {
    code: "ISK",
    description: "Icelandic Króna",
  },
  {
    code: "JMD",
    description: "Jamaican Dollar",
  },
  {
    code: "JPY",
    description: "Japanese Yen",
  },
  {
    code: "KES",
    description: "Kenyan Shilling",
  },
  {
    code: "KGS",
    description: "Kyrgyzstani Som",
  },
  {
    code: "KHR",
    description: "Cambodian Riel",
  },
  {
    code: "KMF",
    description: "Comorian Franc",
  },
  {
    code: "KRW",
    description: "South Korean Won",
  },
  {
    code: "KYD",
    description: "Cayman Islands Dollar",
  },
  {
    code: "KZT",
    description: "Kazakhstani Tenge",
  },
  {
    code: "LAK",
    description: "Lao Kip**",
  },
  {
    code: "LBP",
    description: "Lebanese Pound",
  },
  {
    code: "LKR",
    description: "Sri Lankan Rupee",
  },
  {
    code: "LRD",
    description: "Liberian Dollar",
  },
  {
    code: "LSL",
    description: "Lesotho Loti",
  },
  {
    code: "MAD",
    description: "Moroccan Dirham",
  },
  {
    code: "MDL",
    description: "Moldovan Leu",
  },
  {
    code: "MGA",
    description: "Malagasy Ariary",
  },
  {
    code: "MKD",
    description: "Macedonian Denar",
  },
  {
    code: "MNT",
    description: "Mongolian Tögrög",
  },
  {
    code: "MOP",
    description: "Macanese Pataca",
  },
  {
    code: "MRO",
    description: "Mauritanian Ouguiya",
  },
  {
    code: "MUR",
    description: "Mauritian Rupee**",
  },
  {
    code: "MVR",
    description: "Maldivian Rufiyaa",
  },
  {
    code: "MWK",
    description: "Malawian Kwacha",
  },
  {
    code: "MXN",
    description: "Mexican Peso**",
  },
  {
    code: "MYR",
    description: "Malaysian Ringgit",
  },
  {
    code: "MZN",
    description: "Mozambican Metical",
  },
  {
    code: "NAD",
    description: "Namibian Dollar",
  },
  {
    code: "NGN",
    description: "Nigerian Naira",
  },
  {
    code: "NIO",
    description: "Nicaraguan Córdoba**",
  },
  {
    code: "NOK",
    description: "Norwegian Krone",
  },
  {
    code: "NPR",
    description: "Nepalese Rupee",
  },
  {
    code: "NZD",
    description: "New Zealand Dollar",
  },
  {
    code: "PAB",
    description: "Panamanian Balboa**",
  },
  {
    code: "PEN",
    description: "Peruvian Nuevo Sol**",
  },
  {
    code: "PGK",
    description: "Papua New Guinean Kina",
  },
  {
    code: "PHP",
    description: "Philippine Peso",
  },
  {
    code: "PKR",
    description: "Pakistani Rupee",
  },
  {
    code: "PLN",
    description: "Polish Złoty",
  },
  {
    code: "PYG",
    description: "Paraguayan Guaraní**",
  },
  {
    code: "QAR",
    description: "Qatari Riyal",
  },
  {
    code: "RON",
    description: "Romanian Leu",
  },
  {
    code: "RSD",
    description: "Serbian Dinar",
  },
  {
    code: "RUB",
    description: "Russian Ruble",
  },
  {
    code: "RWF",
    description: "Rwandan Franc",
  },
  {
    code: "SAR",
    description: "Saudi Riyal",
  },
  {
    code: "SBD",
    description: "Solomon Islands Dollar",
  },
  {
    code: "SCR",
    description: "Seychellois Rupee",
  },
  {
    code: "SEK",
    description: "Swedish Krona",
  },
  {
    code: "SGD",
    description: "Singapore Dollar",
  },
  {
    code: "SHP",
    description: "Saint Helenian Pound**",
  },
  {
    code: "SLL",
    description: "Sierra Leonean Leone",
  },
  {
    code: "SOS",
    description: "Somali Shilling",
  },
  {
    code: "SRD",
    description: "Surinamese Dollar**",
  },
  {
    code: "STD",
    description: "São Tomé and Príncipe Dobra",
  },
  {
    code: "SVC",
    description: "Salvadoran Colón**",
  },
  {
    code: "SZL",
    description: "Swazi Lilangeni",
  },
  {
    code: "THB",
    description: "Thai Baht",
  },
  {
    code: "TJS",
    description: "Tajikistani Somoni",
  },
  {
    code: "TOP",
    description: "Tongan Paʻanga",
  },
  {
    code: "TRY",
    description: "Turkish Lira",
  },
  {
    code: "TTD",
    description: "Trinidad and Tobago Dollar",
  },
  {
    code: "TWD",
    description: "New Taiwan Dollar",
  },
  {
    code: "TZS",
    description: "Tanzanian Shilling",
  },
  {
    code: "UAH",
    description: "Ukrainian Hryvnia",
  },
  {
    code: "UGX",
    description: "Ugandan Shilling",
  },
  {
    code: "USD",
    description: "United States Dollar",
  },
  {
    code: "UYU",
    description: "Uruguayan Peso**",
  },
  {
    code: "UZS",
    description: "Uzbekistani Som",
  },
  {
    code: "VND",
    description: "Vietnamese Đồng",
  },
  {
    code: "VUV",
    description: "Vanuatu Vatu",
  },
  {
    code: "WST",
    description: "Samoan Tala",
  },
  {
    code: "XAF",
    description: "Central African Cfa Franc",
  },
  {
    code: "XCD",
    description: "East Caribbean Dollar",
  },
  {
    code: "XOF",
    description: "West African Cfa Franc**",
  },
  {
    code: "XPF",
    description: "Cfp Franc**",
  },
  {
    code: "YER",
    description: "Yemeni Rial",
  },
  {
    code: "ZAR",
    description: "South African Rand",
  },
  {
    code: "ZMW",
    description: "Zambian Kwacha",
  },
];

export const UserStatus = {
  PENDING: "Pending",
  ACTIVATED: "Activated",
  TERMINATED: "Terminated",
  CONFIRMED: "CONFIRMED",
  NOT_CONFIRMED: "NOT_CONFIRMED",
};
